(function($) {

	class PushLogicAjaxHandler {
		constructor() {
		  this.secureToken = null;
		  this.tokenExpiry = 0;
		  this.tokenEndpoint = this.getEndpointUrl() + '/webhook/secure-token';
		  // Fetch the secure token immediately
		  this.fetchSecureToken();
		  // Initialize AJAX setup to insert header and timestamp on requests
		  this.initAjaxSetup();
		  // Refresh the token every 2 minutes (instead of 4) to avoid nearing expiry
		  setInterval(() => { this.fetchSecureToken(); }, 2 * 60 * 1000);
		}
	
		getEndpointUrl() {
		  const host = window.location.host;
		  const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
		  const live_endpoint = 'https://shopify.treasuretrails.co.uk';
	
		  if (host === 'treasure-trails-dev.myshopify.com') {
			return dev_endpoint;
		  } else if (host === 'treasuretrails.co.uk') {
			return live_endpoint;
		  } else {
			return live_endpoint;
		  }
		}
	
		fetchSecureToken() {
		  return fetch(this.tokenEndpoint)
			.then(response => {
			  if (!response.ok) {
				throw new Error('Failed to fetch secure token');
			  }
			  return response.json();
			})
			.then(data => {
			  // Assume the returned JSON has { signature: "...", timestamp: 1234567890 }
			  this.secureToken = data;
			  // Set expiry for 5 minutes from now:
			  this.tokenExpiry = Date.now() + (5 * 60 * 1000);
			  return data;
			})
			.catch(err => {
			  console.error("Error fetching secure token:", err);
			});
		}
	
		initAjaxSetup() {
		  const self = this;
		  $.ajaxSetup({
			beforeSend: function (jqXHR, settings) {
			  // Only add the secure token for endpoints that require it
			  if (settings.url.indexOf('/webhook/') !== -1 || settings.url.indexOf('/checkout/') !== -1) {
				// Check that the secure token exists and is still valid
				if (self.secureToken && Date.now() < self.tokenExpiry) {
				  jqXHR.setRequestHeader('X-Signature', self.secureToken.signature);
				  // If the data is JSON, inject the token's timestamp into the payload
				  if (settings.data && settings.contentType && settings.contentType.indexOf('application/json') !== -1) {
					try {
					  let payload = JSON.parse(settings.data);
					  payload.timestamp = self.secureToken.timestamp;
					  settings.data = JSON.stringify(payload);
					} catch (e) {
					  console.error("Error updating payload timestamp:", e);
					}
				  }
				} else {
				  console.warn("Secure token is missing or expired for request: ", settings.url);
				  // You could abort the request here or choose to force a token refresh.
				  // However, since beforeSend is synchronous, a fully asynchronous refresh is problematic.
				  // An alternative is to simply refresh more frequently (as done above).
				}
			  }
			}
		  });
		}
	}
	
	var PushLogic_Mapbox = {

		init : function()
		{
			this.purge_local_storage();
			this.global_search();
            this.equalizer();
			if(this.get_id() !== undefined)
			{
				this.set_queried_location();
			}
			this.navigation_handler();
		},

		navigation_handler : function()
		{
			var self = this;
			self.storage('ttmb_previous_page', document.referrer, 'set');
		},

		get_endpoint_url : function()
		{
			const host = window.location.host;
			const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
			const live_endpoint = 'https://shopify.treasuretrails.co.uk';
			
			if(host == 'treasure-trails-dev.myshopify.com')
			{
				return dev_endpoint;
			} else if(host == 'treasuretrails.co.uk') {
				return live_endpoint;
			} else {
				return live_endpoint;
			}
		},

		get_pdf_endpoint_url : function()
		{
			const host = window.location.host;
			const dev_endpoint = 'https://dev-pdf.treasuretrails.co.uk';
			const live_endpoint = 'https://pdf.treasuretrails.co.uk';
			
			if(host == 'treasure-trails-dev.myshopify.com')
			{
				return dev_endpoint;
			} else if(host == 'treasuretrails.co.uk') {
				return live_endpoint;
			} else {
				return live_endpoint;
			}
		},
		
		purge_local_storage : function()
		{
			/*
			localStorage.removeItem('ttmb_location_geo');
			localStorage.removeItem('ttmb_location');
			localStorage.removeItem('ttmb_search_geo');
			localStorage.removeItem('ttmb_search_location');
			localStorage.removeItem('ttmb_search_lat');
			localStorage.removeItem('ttmb_search_lng');
			localStorage.removeItem('ttmb_features');
			localStorage.removeItem('ttmb_dataset_id');
			localStorage.removeItem('ttmb_distance');
			localStorage.removeItem('ttmb_answer_data');
			localStorage.removeItem('ttmb_submission_urn');
			localStorage.removeItem('ttmb_submission_data');
			localStorage.removeItem('ttmb_submission_type');
			localStorage.removeItem('ttmb_submission_rating');
			localStorage.removeItem('ttmb_submission_first_name');
			localStorage.removeItem('ttmb_active_product_tags');
			localStorage.removeItem('ttmb_active_product_types');
			localStorage.removeItem('ttmb_active_filter');
			localStorage.removeItem('ttmb_trail_results');
			localStorage.removeItem('ttmb_current_lat');
			localStorage.removeItem('ttmb_current_lng');
			*/
			sessionStorage.removeItem('ttmb_current_tags');
		},
		
		username : function()
		{
			
			return 'treasure-trails';
			
		},

		public_access_token : function()
		{

			return 'pk.eyJ1IjoidHJlYXN1cmUtdHJhaWxzIiwiYSI6ImNrMnVsYm9hMTExa2QzaHB2cHdoOXkyOXoifQ.smsna484gpmCZBuOWRdCYg';

		},
      
		private_access_token : function()
		{

			return 'sk.eyJ1IjoidHJlYXN1cmUtdHJhaWxzIiwiYSI6ImNrZW4wNWltcDExbXgycW53bngwb3hpeGEifQ.MFD7i0tG8OxCYQo_MmRIpg';

		},
		
		loader : function(text = 'Loading...')
		{
			var self = this,
				web_app_endpoint = self.get_endpoint_url();
			return '<div id="ttmb-loader-outer"><div id="ttmb-loader-inner"><img src="' + web_app_endpoint + '/images/tt-logo.png" alt="Treasure Trails"><span>' + text + '</span></div></div>';
		},
		
		file_mode : function(file_mode = true)
		{
			return file_mode;
		},
		
		get_type : function()
		{
			
			var map_target = $('#mapbox-renderer');
			
			if(
				map_target.length > 0 && 
				typeof map_target.data('mapbox-id') !== 'undefined' && 
				map_target.data('mapbox-id') && 
				typeof map_target.data('type') !== 'undefined' && 
				map_target.data('type')
			) {
				
				return $('#mapbox-renderer').attr('data-type');
				
			}
			
		},
		
		get_id : function()
		{
			
			if($('#mapbox-renderer').length > 0)
			{
			
				return $('#mapbox-renderer').attr('data-mapbox-id');
			
			}
			
		},
		
		get_lat : function()
		{
			
			if($('#mapbox-renderer').length > 0 && typeof $('#mapbox-renderer').attr('data-lat') !== typeof undefined && $('#mapbox-renderer').attr('data-lat') !== false)
			{
				
				return $('#mapbox-renderer').attr('data-lat');
				
			} else {
				
				return 54.2316643;
				
			}
			
		},
		
		get_lng : function()
		{
			
			if($('#mapbox-renderer').length > 0 && typeof $('#mapbox-renderer').attr('data-lng') !== typeof undefined && $('#mapbox-renderer').attr('data-lng') !== false)
			{
				
				return $('#mapbox-renderer').attr('data-lng');
				
			} else {
				
				return -5.4266682;
				
			}
			
		},
		
		get_filtered_products : function(get_filtered = true)
		{
			
			if($('#mapbox-renderer').attr('data-products') !== undefined && $('#mapbox-renderer').attr('data-products').length > 0 && $('#mapbox-renderer').attr('data-products') !== '')
			{
				
				var products        = $('#mapbox-renderer').attr('data-products'),
                    products        = $.trim(products),
                    product_counter = (products.split(' ').length - 1);

				if(product_counter > 0)
				{
					
					var filters = ['any'];
					
					products = products.split(' ');
					
					$.each(products, function(i)
					{
						
						filters.push(['==', 'product_id', parseInt(products[i])]);
						
					});
					
					if(get_filtered)
					{
					
						return filters;
						
					} else {
						
						var product_ids = _.map(products, Number);
						return product_ids;
						
					}
					
				} else {
					
					var filters = ['any'];
					filters.push(['==', 'product_id', parseInt(products)]);
					
					if(get_filtered)
					{
					
						return filters;
						
					} else {
						
						return parseInt(products);
						
					}
					
				}	
				
			}
			
		},
		
        storage : function(name, value, type)
        {

            if(typeof(Storage) !== 'undefined')
            {

                if(type == 'set')
                {

                    sessionStorage.setItem(name, value);

                } else if(type == 'get') {

                    sessionStorage.getItem(name);

                } else if(type == 'remove') {

                    sessionStorage.removeItem(name);

                }

            }

        },
		
		add_map_status : function()
		{
			
			var map_target = $('#mapbox-container'),
				status     = navigator.onLine ? 'online' : 'offline';
			
			if(map_target.length > 0)
			{
				
				if(status == 'online')
				{
					
					map_target.removeClass('ttmb-status-offline');
					map_target.addClass('ttmb-status-online');
					
				} else {
					
					map_target.removeClass('ttmb-status-online');	
					map_target.addClass('ttmb-status-offline');
					
				}
				
			}
			
		},
		
		get_queried_location : function(return_geo = true)
		{
			
			var self    = this,
				filters = $('#cloud_search_filters_root');
			
			if(filters.length > 0 && filters.attr('data') !== '')
			{
				
				var return_data = JSON.parse(filters.attr('data'));
				
				if(return_data.query !== 'undefined' && return_data.query !== '')
				{
					
					if(return_geo)
					{
						
						var encoded_location = encodeURIComponent(return_data.query),
							mapbox_geo_api   = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encoded_location + '.json?country=GB&types=region,postcode,place,locality,poi&autocomplete=true&access_token=' + self.public_access_token();
							
						$.getJSON(mapbox_geo_api, function(data)
						{
							
							self.storage('ttmb_location_geo', JSON.stringify(data), 'set');
							self.storage('ttmb_location', return_data.query, 'set');
							
						});
						
					} else {
						
						return return_data.query;
						
					}
					
				}
				
			}			
			
		},
      
		get_searched_location : function(search_text, form, is_global_search = false)
		{
			
			var self = this;
			
			if(search_text && search_text !== '')
			{
			
				var encoded_location = encodeURIComponent(search_text),
					mapbox_geo_api   = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encoded_location + '.json?country=GB&types=region,postcode,place,locality,district,poi&autocomplete=true&access_token=' + self.public_access_token();
					
				// var mapbox_geo_api   = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encoded_location + '.json?country=GB&types=region,postcode,place,locality&autocomplete=true&access_token=' + self.public_access_token();
			
				$.ajax({

					type: 'GET',
					url: mapbox_geo_api,
					crossDomain: true,/*
					data: $(this).serialize(),
					dataType: 'json',*/

					success : function(data) 
					{
						
						// Add body class
						$('body').addClass('ttmb-search-query-active');

						// Store GEO data
						self.storage('ttmb_search_geo', JSON.stringify(data), 'set');
						
						// Remove autocomplete
						
						$('.ttmb-search-autocomplete').remove();
						
						// Add autocomplete
						
						var autocomplete = self.build_autocomplete(data);
						$(autocomplete).appendTo(form);
						self.autocomplete_click_handler(form, is_global_search);
					},

					error: function (jqXHR, exception)
					{

						var error = '';

						if (jqXHR.status === 0) {
							error = 'Can\'t connect.\n Verify Network.';
						} else if (jqXHR.status == 404) {
							error = 'Requested page not found. [404]';
						} else if (jqXHR.status == 500) {
							error = 'Internal Server Error [500].';
						} else if (exception === 'parsererror') {
							error = 'Requested JSON parse failed.';
						} else if (exception === 'timeout') {
							error = 'Time out error.';
						} else if (exception === 'abort') {
							error = 'Ajax request aborted.';
						} else {
							error = 'Uncaught Error.\n' + jqXHR.responseText;
						}

						alert(error);

					},

				});
				
			}
			
		},
		
		build_autocomplete : function(data)
		{
			
			var results = data.features;
			
			if(results.length > 0)
			{
				
				var html = '<div class="ttmb-search-autocomplete">';
				
				$.each(results, function(i)
				{
					
					var data_index = i;
					
					html = html + '<div class="ttmb-search-autocomplete-item" data-index="' + data_index + '" data-lat="' + results[i].geometry.coordinates[1] + '" data-lng="'+ results[i].geometry.coordinates[0] + '" data-name="' + results[i].place_name + '"><address>' + results[i].place_name + '</address></div>';
					
				});
				
				html = html + '</div>';
				
				return html;
				
			}
			
		},
		
		autocomplete_click_handler : function(form, is_global_search)
		{
			
			var self = this;

			// if(is_global_search) {
				/*
				$(document).off('click', '.ttmb-search-autocomplete-item').on('click', '.ttmb-search-autocomplete-item', function()
				{
					console.log('Global Search');
					$(form).submit();
				});
				*/
			// } else {
				$(document).off('click', '.ttmb-search-autocomplete-item').on('click', '.ttmb-search-autocomplete-item', function()
				{
					var list_item = $(this),
						title = list_item.data('name'),
						lat   = list_item.data('lat'),
						lng   = list_item.data('lng'),
						wrap  = list_item.closest('.ttmb-search-autocomplete');

					$(self.loader()).appendTo('body');
						
					// Fade out autocomplete and remove element
						
					wrap.fadeOut(function()
					{
						
						$(this).remove();
						
					});
					
					// Filter selection through smart queries
					
					self.smart_queries(title);
					
					// Store queried location
					
					self.storage('ttmb_search_location', title, 'set');
					self.storage('ttmb_search_lat', lat, 'set');
					self.storage('ttmb_search_lng', lng, 'set');
					
					// Set the value within the search field
					
					$(form + ' input[type="search"]').val(title.split(',')[0]);
					
					setTimeout(function()
					{

						// Refresh
						
						var current_value = $(form + ' input[type="search"]');
						var split_current_val = current_value.val().split(',');
						var form_action = $(form).attr('action');
						
						if (typeof attr !== typeof undefined && attr !== false) {
							window.history.replaceState("", "", form_action);
							setTimeout(function()
							{
							$('#ttmb-loader-outer').remove();
							}, 2000);
						} else {
							// If there are no search parameters, redirect back to the homepage
							window.location.replace("/");
						}
						
						if('URLSearchParams' in window) {
							var searchParams = new URLSearchParams(window.location.search);
							searchParams.set(current_value.attr('name'), split_current_val[0]);
							window.location.search = searchParams.toString();
						}
					}, 2000);
				});
			// }
		},
		
		sort_data : function(key, data, type, value_type = 'numbers')
		{
			
			let ordered = {};
			
			let compareFunction = function(a, b)
			{
				
				if(value_type == 'numbers')
				{
					return data[b][key] - data[a][key];
				} else {
					return data[b][key].toLowerCase() - data[a][key].toLowerCase();
				}
			
			};
			
			if(type === "asc")
			{
				
				compareFunction = function(a, b)
				{
					
					if(value_type == 'numbers')
					{
						return data[a][key] - data[b][key];
					} else {
						return data[a][key].toLowerCase() - data[b][key].toLowerCase();
					}
					
				}
			
			}
			
			Object.keys(data).sort(compareFunction).forEach(function(key)
			{
				
				if(value_type == 'numbers')
				{
					ordered[key] = data[key];
				} else {
					ordered[key] = data[key];
				}
			
			});
			
			return ordered;
			
		},
		
		sort_geojson : function(props)
		{
		  if (!props instanceof Array) props = props.split(",");
		  return function sort(a, b) {
			var p;
			a = a.properties;
			b = b.properties;
			for (var i = 0; i < props.length; i++) {
			  p = props[i];
			  if (typeof a[p] === "undefined") return -1;
			  if (a[p].toLowerCase() < b[p].toLowerCase()) return -1;
			  if (a[p].toLowerCase() > b[p].toLowerCase()) return 1;
			}
			return 0;
		  };
		},
		
		load_more : function(element, button, items = 12)
		{
			
			$(element).slice(0, items).show();
			
			if($(element).length <= items)
			{
				$(button).hide();
			} else {
				$(button).show();
			}
			
			$(button).on('click', function(e)
			{
				
				e.preventDefault();
				
				$('html,body').animate(
				{
					scrollTop: $(this).offset().top - 80
				}, 500);
				
				$(element + ':hidden').slice(0, items).slideDown();
				
				if($(element + ':hidden').length == 0)
				{
					$(button).fadeOut('slow');
				}
				
			});
			
		},
		
		trail_filters_reshuffle : function(html)
		{
			
			$('#getting-around-6').insertBefore('#getting-around-3');
			$('#getting-around-5').insertAfter('#getting-around-3');
			
		},
		
		trail_filters_html : function()
		{
			
			var self		    = this,
				product_types   = $('#mapbox-renderer').attr('data-product-types').split(', ').sort(),
				product_filters = $('#mapbox-renderer').attr('data-filters').split(', ').sort(),
				html            = '<div id="ttmb-trail-filters"><h2><span>Filters</span><span class="ttmb-filter-close"></span></h2><div><form>';
				
			if(sessionStorage.hasOwnProperty('ttmb_current_tags'))
			{
				tags = JSON.parse(sessionStorage.getItem('ttmb_current_tags'));
			} else {
				tags = product_filters;
			}
				
			/*
				
			if(product_types)
			{
				
				html = html + '<h3>Trail Types</h3>';
				
				$.each(product_types, function(index, product_type)
				{
					if(product_type !== 'Gift Voucher' && product_type !== 'MM' && product_type !== '')
					{
						if(sessionStorage.hasOwnProperty('ttmb_active_product_types'))
						{
							var active_product_types = JSON.parse(sessionStorage.getItem('ttmb_active_product_types'));

							if($.inArray(product_type, active_product_types) !== -1)
							{
								html = html + '<label><input type="checkbox" name="trail_types" value="' + product_type + '" checked><span>' + product_type + '</span></label>';
							} else {
								html = html + '<label><input type="checkbox" name="trail_types" value="' + product_type + '"><span>' + product_type + '</span></label>';
							}
						} else {
							html = html + '<label><input type="checkbox" name="trail_types" value="' + product_type + '"><span>' + product_type + '</span></label>';
						}
					}
				});
				
			}
			
			*/
				
			if(tags)
			{
				
				// Sort Tags Alphabetically
				
				tags.sort();
				
				// Reverse, so descending
				
				tags.reverse();
				
				// Build Tag Groups
				
				var tag_groups = {};

				$.each(tags, function(index, tag)
				{
					
					if(tag.indexOf(':') >= 0)
					{

						var split_tag = tag.split(':'),
							tag_group = $.trim(split_tag[0]),
							tag_label = $.trim(split_tag[1]);

						tag_group = tag_group.toLowerCase().replace(/\b[a-z]/g, function(letter) {
							return letter.toUpperCase();
						});
							
						tag_groups[tag_group] = tag_group;
						
					}
					
				});
				
				// Sort Tags Alphabetically, again
				
				tags.sort();

				// Add Tags to their respective Tag Group
				
				$.each(tag_groups, function(group_index, tag_group)
				{
					
					var tags_to_push = [];
					
					$.each(tags, function(tag_index, tag)
					{
						/*
						if(tag == 'Getting Around : Driving and Walking' || tag == 'Getting Around : Cycling between Clues'  || tag == 'Getting Around : Cycling between Clues') {
							// Don't alter query
						} else {
							tag = tag.toLowerCase().replace(/\b[a-z]/g, function(letter) {
								return letter.toUpperCase();
							});
						}
						*/
						
						var split_tag = tag.split(':'),
							tag_label = $.trim(split_tag[1]);
							
						if(tag.indexOf(tag_group) >= 0)
						{
					
							tags_to_push.push({label: tag_label, value: tag});
						
						}
						
					});
					
					tag_groups[tag_group] = tags_to_push
					
				});
				
				$.each(tag_groups, function(tag_group, tags)
				{
					
					html = html + '<h3>' + tag_group + '</h3>';
					
					$.each(tags, function(index, tag)
					{
						var label_id = tag_group.toLowerCase().replace(' ', '-') + '-' + index;
						if(tag !== '')
						{
							if(sessionStorage.hasOwnProperty('ttmb_active_product_tags'))
							{
								var active_product_tags = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags'));
								if($.inArray(tag.value, active_product_tags) !== -1)
								{
									html = html + '<label id="' + label_id + '"><input type="checkbox" name="trail_tags" value="' + tag.value + '" checked><span>' + tag.label + '</span></label>';
								} else {
									html = html + '<label id="' + label_id + '"><input type="checkbox" name="trail_tags" value="' + tag.value + '"><span>' + tag.label + '</span></label>';
								}
							} else {
								html = html + '<label id="' + label_id + '"><input type="checkbox" name="trail_tags" value="' + tag.value + '"><span>' + tag.label + '</span></label>';
							}
						}
					});
					
				});
				
				/*
				
				$.each(tags, function(index, tag)
				{
					if(tag !== '')
					{
						if(sessionStorage.hasOwnProperty('ttmb_active_product_tags'))
						{
							var active_product_tags = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags'));
							if($.inArray(tag, active_product_tags) !== -1)
							{
								html = html + '<label><input type="checkbox" name="trail_tags" value="' + tag + '" checked><span>' + tag + '</span></label>';
							} else {
								html = html + '<label><input type="checkbox" name="trail_tags" value="' + tag + '"><span>' + tag + '</span></label>';
							}
						} else {
							html = html + '<label><input type="checkbox" name="trail_tags" value="' + tag + '"><span>' + tag + '</span></label>';
						}
					}
				});
				
				*/
				
			}
			
			html = html + '<div id="ttmb-filter-validation"></div><input type="submit" value="Submit Filters">';
			
			html = html + '</form></div></div>';
			
			return html;
			
		},

		trail_filter_toggle_html : function()
		{
			
			return '<div id="ttmb-filter-nav-toggle-outer"><div id="ttmb-filter-nav-toggle"><span class="ttmb-filter-toggle"></span><span>Filter</span></div></div>';
			
		},
		
		active_trail_filters : function()
		{
			
			if(sessionStorage.hasOwnProperty('ttmb_active_product_tags'))
			{
				
				var active_product_tags = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags')),
				//	tag_html = '<ul class="ttmb-active-tags">';
					tag_html = '';
					
				$.each(active_product_tags, function(index, tag)
				{
					
					tag_html = tag_html + '<li>' + tag + '</li>';
					
				});
				
				// tag_html = tag_html + '</ul>';
					
			} else {var tag_html = '';}
			
			if(sessionStorage.hasOwnProperty('ttmb_active_product_types'))
			{
				
				var active_product_types = JSON.parse(sessionStorage.getItem('ttmb_active_product_types')),
				// 	type_html = '<ul class="ttmb-active-types">';
					type_html = '';
				
				$.each(active_product_types, function(index, type)
				{
					
					type_html = type_html + '<li>' + type + '</li>';
					
				});
				
				// type_html = type_html + '</ul>';
				
			} else {var type_html = '';}
			
			var toggle = $('#ttmb-filter-nav-toggle');
			
			if(toggle.length > 0 && type_html !== '' || tag_html !== '')
			{
			
				toggle.find('ul').remove();
				$('<ul id="ttmb-active-filters">' + tag_html + type_html + '</ul>').appendTo(toggle);
			
			}
			
			$('#ttmb-active-filters li').on('click', function()
			{

				var filter = $(this).text();
				
				if(sessionStorage.hasOwnProperty('ttmb_active_product_tags'))
				{

					var active_product_tags = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags'));
					
					if($.inArray(filter, active_product_tags) !== -1)
					{
						
						var updated_product_tags = active_product_tags.filter(function(elem)
						{
							return elem != filter; 
						});
						
						if(updated_product_tags.length === 0)
						{
							sessionStorage.removeItem('ttmb_active_product_tags');
							location.reload(); 
						} else {
							sessionStorage.setItem('ttmb_active_product_tags', JSON.stringify(updated_product_tags));
							location.reload(); 
						}
						
					}
					
				}
				
				if(sessionStorage.hasOwnProperty('ttmb_active_product_types'))
				{

					var active_product_types = JSON.parse(sessionStorage.getItem('ttmb_active_product_types'));
					
					if($.inArray(filter, active_product_types) !== -1)
					{
						
						var updated_product_types = active_product_types.filter(function(elem)
						{
							return elem != filter; 
						});
						
						if(updated_product_types.length === 0)
						{
							sessionStorage.removeItem('ttmb_active_product_types');
							location.reload(); 
						} else {
							sessionStorage.setItem('ttmb_active_product_types', JSON.stringify(updated_product_types));
							location.reload(); 
						}
						
					}
					
				}
				
			});
			
		},
		
		sticky_element : function(element, container)
		{
			
			$(document).ready(function()
			{
				
				var stickyTop = $(element).offset().top;
				
				$(window).scroll(function()
				{
					
					var windowTop = $(window).scrollTop();
					
					if(stickyTop < windowTop && $(container).height() + $(container).offset().top - $(element).height() > windowTop)
					{
						
						$(element).css('position', 'sticky').css('top', 0).css('left', 0).css('right', 0);
						$(container).addClass('ttmb-is-sticky');
						
					} else {
						
						$(element).css('position', 'static');
						$(container).removeClass('ttmb-is-sticky');
						
					}
					
				});
				
			});
			
		},
		
		trail_filter_click_handler : function()
		{
			
			var self = this;
			
			$('#ttmb-filter-nav-toggle-inner, .ttmb-filter-close').on('click', function()
			{
				
				$('#ttmb-trail-filters').toggleClass('ttmb-filter-open');
				
			});
			
			$('#ttmb-trail-filters form').on('submit', function(e)
			{
				
				e.preventDefault();
				
				self.store_trail_filter_array($(this).serializeArray());
				
				window.location.reload();
				
			});
			
			self.active_trail_filters();
			
		},
		
		store_trail_filter_array : function(data)
		{
			
			var tags_array  = [];
			var types_array = [];
			
			if(data)
			{
				
				$.each(data, function(index, input)
				{
					
					if(input.name == 'trail_types')
					{
					
						types_array.push(input.value);
					
					} else {
						
						tags_array.push(input.value);
						
					}
					
				});
				
				if(tags_array.length > 0)
				{
				
					sessionStorage.setItem('ttmb_active_product_tags', JSON.stringify(tags_array));
				
				} else {
					
					sessionStorage.removeItem('ttmb_active_product_tags');
					
				}
				
				if(types_array.length > 0)
				{
				
					sessionStorage.setItem('ttmb_active_product_types', JSON.stringify(types_array));
				
				} else {
					
					sessionStorage.removeItem('ttmb_active_product_types');
					
				}
				
			}
			
		},
		
		build_map_by_region : function(features, map)
		{
			
			var self = this;
			var active_features = features;
			
			// --- Rebuild the Map on queried location
			
			// Iterate through each feature to set bounds against feature if Product ID matches
				
			var filters = ['any'];
			var products = new Array();
				
			var bounds      = new mapboxgl.LngLatBounds(),
				bound_count = 0;
			
			$.each(active_features, function(index, feature)
			{
				
				if(!map.getLayer(feature.id))
				{
						
					if(sessionStorage.hasOwnProperty('ttmb_active_product_tags') || sessionStorage.hasOwnProperty('ttmb_active_product_types'))
					{
						
						var filter_properties = feature.properties.product_tags,
							current_tags      = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags')),
							current_types     = JSON.parse(sessionStorage.getItem('ttmb_active_product_types')),
							validated         = [];
							
						// filter_properties.push(feature.properties.product_type);
							
						// Iterate through and check current_tags
							
						$.each(current_tags, function(index, tag)
						{
							
							if($.inArray(tag, filter_properties) !== -1)
							{
								
								validated.push(true);
								
							} else {
								
								validated.push(false);
								
							}
							
						});
						
						if(sessionStorage.hasOwnProperty('ttmb_active_product_types') && feature.properties.product_type !== null)
						{
						
							// Check if product type is filtered
							
							feature.properties.product_type = feature.properties.product_type.replace('Secret ', '');
								
							if($.inArray(feature.properties.product_type, current_types) !== -1)
							{
								
								validated.push(true);
								
							} else {
								
								validated.push(false);
								
							}
						
						}
						
						// Check validation array and add product if all are validated
						
						var all_validated = !validated.some(x => x === false);
						
						if(all_validated)
						{
							
							filters.push(['==', 'product_id', feature.properties.product_id]);
							products[feature.properties.product_id] = feature;
							
						}
						
					} else {
						
						filters.push(['==', 'product_id', feature.properties.product_id]);
						products[feature.properties.product_id] = feature;
					
					}
					
					feature.name = feature.properties.name.toLowerCase();
						
					bounds.extend(feature.geometry.coordinates);
					bound_count++;
					
				}
				
			});
			
			if(map.getLayer(self.get_id())) {
			
				map.removeLayer(self.get_id());
			
			}
			
			map.addLayer({
				'id': self.get_id(),
				'type': 'symbol',
				'source': self.get_id(),
				'layout': {
					'icon-image': 'tt_map_icon',
					'icon-size': 0.9,
					'icon-allow-overlap': true
				},
				'filter': filters
			});
				
			if(bound_count > 2)
			{
			
				map.fitBounds(bounds, {padding: 50});
			
			} else {
			
				map.fitBounds(bounds, {padding: 50, maxZoom: 15});
			
			}
			
			// Store trail results
			
			sessionStorage.setItem('ttmb_trail_results', JSON.stringify(self.sort_data('name', products, 'asc')));
			
			// Update page title
			
			var result_title_data = ' (' + Object.keys(products).length + ' Trails)';
			
			var original_title = $('.section-header .search-hero__title');
			
			// original_title.empty();
			
			original_title.text(original_title.text() + result_title_data);
			
		},
		
		build_filter_results : function(features, map, bounds)
		{
			var filters = ['any'];
			
			$.each(features, function(index, feature)
			{
				
				if(!map.getLayer(feature.id))
				{

					if(sessionStorage.hasOwnProperty('ttmb_active_product_tags') || sessionStorage.hasOwnProperty('ttmb_active_product_types'))
					{
						
						var filter_properties = feature.properties.product_tags,
							current_tags      = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags')),
							current_types     = JSON.parse(sessionStorage.getItem('ttmb_active_product_types')),
							validated         = [];
							
						// filter_properties.push(feature.properties.product_type);
							
						// Iterate through and check current_tags
							
						$.each(current_tags, function(index, tag)
						{
							
							if($.inArray(tag, filter_properties) !== -1)
							{
								
								validated.push(true);
								
							} else {
								
								validated.push(false);
								
							}
							
						});
						
						if(sessionStorage.hasOwnProperty('ttmb_active_product_types') && feature.properties.product_type !== null)
						{
						
							// Check if product type is filtered
							
							feature.properties.product_type = feature.properties.product_type.replace('Secret ', '');
								
							if($.inArray(feature.properties.product_type, current_types) !== -1)
							{
								
								validated.push(true);
								
							} else {
								
								validated.push(false);
								
							}
						
						}
						
						// Check validation array and add product if all are validated
						
						var all_validated = !validated.some(x => x === false);
						
						if(all_validated)
						{
							
							filters.push(['==', 'product_id', feature.properties.product_id]);
							
						}
						
					} else {
						
						filters.push(['==', 'product_id', feature.properties.product_id]);
					
					}
				
					bounds.extend(feature.geometry.coordinates);
					
				}
				
			});
			return filters;
		},
		
		product_html : function(feature, trails_nearby = false)
		{
			var self = this,
				html = '',
				product_desc  = $(feature.properties.description);
				
			if(sessionStorage.hasOwnProperty('ttmb_search_location'))
			{
				
				var full_location = sessionStorage.getItem('ttmb_search_location').split(',');
				
			} else {
				
				var full_location = null;
				
			}
			
			var current_path = window.location.pathname;
			
			if(current_path == '/')
			{
				trails_nearby = true;
				query_page = true;
				var lng = sessionStorage.getItem('ttmb_current_lng'),
					lat = sessionStorage.getItem('ttmb_current_lat');
			} else if(~current_path.indexOf('trail-search'))
			{
				query_page = true;
				var lng = sessionStorage.getItem('ttmb_search_lng'),
					lat = sessionStorage.getItem('ttmb_search_lat');
			} else if(~current_path.indexOf('collections'))
			{
				
			}
			
			if(lng !== undefined && lat !== undefined)
			{
			
				var to = [lng, lat],
					from = feature.geometry.coordinates,
					options = {
						units: 'miles'
					},
					distance = turf.distance(to, from, options);
				
			}
			
			if(product_desc.hasClass('ttmb-feature-offline'))
			{
				html = html + '<div class="ttmb-bestseller ttmb-feature-offline">';
			} else {
				html = html + '<div class="ttmb-bestseller">';
			}

			html = html + '<div class="ttmb-trail-result-inner">';

            html = html + '<a href="' + feature.properties.product_url + '">';
			
				html = html + '<img class="lazyload" data-src="' + feature.properties.product_image + '" alt="' + feature.properties.name + '">';
			
			html = html + '</a>';
		
			html = html + '<a href="' + feature.properties.product_url + '">';
		
				html = html + '<h3>' + feature.properties.name + '</h3>';
				
				if(feature.properties.product_type !== null)
				{
					html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + ' | ' + feature.properties.product_type + '</p>';
				} else {
					html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + '</p>';
				}
				
				if(query_page && distance !== undefined)
				{
					if(trails_nearby)
					{
						html = html + '<span class="ttmb-distance-to">' + distance.toFixed(1) + ' miles from completed Trail</span>';
					} else if(full_location !== null) {
						html = html + '<span class="ttmb-distance-to">' + distance.toFixed(1) + ' miles from ' + full_location[0] + '</span>';
					}
				}
				
				if(feature.properties.product_reviews !== 'null' || feature.properties.product_reviews !== null)
				{
					var product_reviews = feature.properties.product_reviews;
					if(product_reviews && product_reviews.avarage_rating !== null && product_reviews.reviews_count !== null)
					{
						html = html + self.build_reviews_html(feature.properties.product_id, product_reviews);
					}
				}
				
				/*
				
				if(feature.properties.product_subtitle)
				{
					html = html + '<p class="ttmb-popup-content-subtitle"><strong>' + feature.properties.product_subtitle + '</strong></p>';
				}
				
				if(feature.properties.product_description)
				{
					html = html + '<p class="ttmb-popup-content-desc">' + $.trim($(feature.properties.product_description).text()).substring(0, 110).split(' ').slice(0, -1).join(' ') + '...</p>';
				}
				
				*/

				if(feature.properties.product_price)
				{
					html = html + '<p class="ttmb-popup-content-price">Only &pound;' + feature.properties.product_price + '</p>';
				}
				
				html = html + '<span class="tt-add-to-cart btn btn--small">Buy Now</span>';
			
			html = html + '</a>';
			
			if(product_desc.hasClass('ttmb-feature-offline'))
			{
			
				html = html + '<div class="tempoffline"><p>Temporarily offline <a data-fancybox="" data-src="#' + feature.properties.product_id + '-offline-standard" href="javascript:;" class="why" aria-describedby="a11y-external-message">Why?</a></p><div style="display:none;" id="' + feature.properties.product_id + '-offline-standard"><div class="offlineTitle"><p class="h4 grid-view-item__title product-card__title">Why is ' + feature.properties.name + ' offline?</p></div><p>We\'re really sorry but this Trail is currently unavailable to buy. We\'re working hard to resolve this as quickly as possible, so please bear with us. If you would like to know more, please contact us, or why not try one of our other exciting adventures nearby?</p></div></div>';
			
			}
			
			html = html + '</div></div>';

			return html;
		},
		
		smart_queries : function(queried_location)
		{
			var child_list_items = $('.site-nav__childlist-item ul li a'),
				location = queried_location.split(', ');
				
			// Redirect to Collections page if Search Query Matches

			if(child_list_items.length > 0)
			{
				$.each(child_list_items, function(index, value)
				{
					var region_element = $(this),
						region_url = region_element.attr('href'),
						region_name = region_element.text().trim();
						
					if(region_element.attr('href') !== '#' && region_name.toLowerCase() == location[0].toLowerCase())
					{
						window.location.href = region_element.attr('href');
					}
				});
			}
		},
		
		bestsellers_by_query : function(products, active_product_ids, default_distance = 10)
		{
			var self     = this,
				web_app_endpoint = self.get_endpoint_url(),
				endpoint = web_app_endpoint + '/storage/json/all-bestsellers.json',
				product_counter = 0,
				bestsellers = $('#ttmb-bestsellers'),
				bestsellers_title = $('#ttmb-bestsellers-title'),
				html = '';
				
			$.ajax({

				type: 'GET',
				url: endpoint,
				dataType: 'json',
				crossDomain: true,

				success : function(data)
				{
					var product_ids = data;
					
					if(product_ids)
					{
						$.each(product_ids, function(index, product_id)
						{
							if(
								$.inArray(product_id, active_product_ids) !== -1 && 
								products[product_id].properties.enable_purchase && 
								products[product_id].properties.distance_to <= default_distance
							) {
								product_counter = product_counter + 1;
								if(product_counter <= 4)
								{
									html = html + self.product_html(products[product_id]);
								}
							}
						});
						bestsellers.empty();
						$(html).appendTo(bestsellers);
						bestsellers_title.text(bestsellers_title.text() + ' based off your search...');
					}

				},

				error: function (jqXHR, exception)
				{
					
					/*

					var error = '';

					if (jqXHR.status === 0) {
						error = 'Can\'t connect.\n Verify Network.';
					} else if (jqXHR.status == 404) {
						error = 'Requested page not found. [404]';
					} else if (jqXHR.status == 500) {
						error = 'Internal Server Error [500].';
					} else if (exception === 'parsererror') {
						error = 'Requested JSON parse failed.';
					} else if (exception === 'timeout') {
						error = 'Time out error.';
					} else if (exception === 'abort') {
						error = 'Ajax request aborted.';
					} else {
						error = 'Uncaught Error.\n' + jqXHR.responseText;
					}

					alert(error);
					
					*/

				},

			});
		},
		
		build_map_by_location : function(features, map, lat, lng, add_results = true, is_stockist = true, filterable = false)
		{
			
			var self = this,
				active_features = features,
				active_product_ids = [];
			
			lat = parseFloat(lat);
			lng = parseFloat(lng);
			
			// --- Rebuild the Map on queried location
			
			// Iterate through each feature to set bounds against feature if Product ID matches
				
			var filters = ['any'];
			var products = {};
				
			var bounds      = new mapboxgl.LngLatBounds(),
				bound_count = 0;
			
			$.each(active_features, function(index, feature)
			{
				
				if(!map.getLayer(feature.id))
				{

					var to = [lng, lat],
						from = feature.geometry.coordinates,
						options = {
							units: 'miles'
						},
						distance = turf.distance(to, from, options);
						
					if(distance <= sessionStorage.getItem('ttmb_distance'))
					{
						
						if(is_stockist)
						{

							filters.push(['==', 'title', feature.properties.title]);
						
						} else {
							
							if(filterable && sessionStorage.hasOwnProperty('ttmb_active_product_tags') || sessionStorage.hasOwnProperty('ttmb_active_product_types'))
							{
								
								var filter_properties = feature.properties.product_tags,
									current_tags      = JSON.parse(sessionStorage.getItem('ttmb_active_product_tags')),
									current_types     = JSON.parse(sessionStorage.getItem('ttmb_active_product_types')),
									validated         = [];
									
								// filter_properties.push(feature.properties.product_type);
									
								// Iterate through and check current_tags
									
								$.each(current_tags, function(index, tag)
								{
									
									if($.inArray(tag, filter_properties) !== -1)
									{
										
										validated.push(true);
										
									} else {
										
										validated.push(false);
										
									}
									
								});
								
								if(sessionStorage.hasOwnProperty('ttmb_active_product_types') && feature.properties.product_type !== null)
								{
								
									// Check if product type is filtered
									
									feature.properties.product_type = feature.properties.product_type.replace('Secret ', '');
										
									if($.inArray(feature.properties.product_type, current_types) !== -1)
									{
										
										validated.push(true);
										
									} else {
										
										validated.push(false);
										
									}
								
								}
								
								// Check validation array and add product if all are validated
								
								var all_validated = !validated.some(x => x === false);
								
								if(all_validated)
								{
									
									filters.push(['==', 'product_id', feature.properties.product_id]);
									products[feature.properties.product_id] = feature;
									active_product_ids.push(feature.properties.product_id);
									
								}
								
							} else {
								
								filters.push(['==', 'product_id', feature.properties.product_id]);
								products[feature.properties.product_id] = feature;
								active_product_ids.push(feature.properties.product_id);
							
							}
							
						}
						
						feature.properties.distance_to = distance.toFixed(1);
						feature.distance               = distance.toFixed(1);
						bounds.extend(feature.geometry.coordinates);
						bound_count++;
						
					} else {
						
						delete active_features[index];
						
					}
					
				}
				
			});
			
			if(is_stockist)
			{
				
				if(filters.length > 1)
				{
				
					if(map.getLayer(self.get_id())) {
					
						map.removeLayer(self.get_id());
					
					}
					
					map.addLayer({
						'id': self.get_id(),
						'type': 'symbol',
						'source': self.get_id(),
						'layout': {
							'icon-image': 'tt_map_icon',
							'icon-size': 0.9,
							'icon-allow-overlap': true
						},
						'filter': filters
					});
					
					var radius = new MapboxCircle({lat: lat, lng: lng}, self.miles_to_meter(sessionStorage.getItem('ttmb_distance')), {
							editable: false,
							minRadius: self.miles_to_meter(sessionStorage.getItem('ttmb_distance')),
							fillColor: '#0297d6'
						}).addTo(map);
						
					if(bound_count > 2)
					{
					
						map.fitBounds(bounds, {padding: 50});
					
					} else {
					
						map.fitBounds(bounds, {padding: 50, maxZoom: 15});
					
					}
				
				} else {
					
					$('#ttmbs-results').remove();
					$('<div class="ttmbs-result-count">No stockists found within the search location and radius. Please try another search or widen your search radius.</p>').appendTo($('#ttmbs-left'));
					
				}
				
			} else {
				
				// Set Bestsellers by Query
				
				self.bestsellers_by_query(products, active_product_ids);
				
				if(map.getLayer(self.get_id())) {
				
					map.removeLayer(self.get_id());
				
				}
				
				map.addLayer({
					'id': self.get_id(),
					'type': 'symbol',
					'source': self.get_id(),
					'layout': {
						'icon-image': 'tt_map_icon',
						'icon-size': 0.9,
						'icon-allow-overlap': true
					},
					'filter': filters
				});
				
				var radius = new MapboxCircle({lat: lat, lng: lng}, self.miles_to_meter(sessionStorage.getItem('ttmb_distance')), {
						editable: false,
						minRadius: self.miles_to_meter(sessionStorage.getItem('ttmb_distance')),
						fillColor: '#0297d6'
					}).addTo(map);
					
				if(bound_count > 2)
				{
				
					map.fitBounds(bounds, {padding: 50});
				
				} else {
				
					map.fitBounds(bounds, {padding: 50, maxZoom: 15});
				
				}
				
			}
			
			// Add Search Results
			
			if(add_results)
			{
			
				$(self.stockists_results(features, true)).appendTo($('#ttmbs-results'));
			
			}
			
			if(!is_stockist)
			{
				
				if(self.get_type() == 'search')
				{
				
					sessionStorage.setItem('ttmb_trail_results', JSON.stringify(self.sort_data('distance', products, 'asc')));

					if(sessionStorage.hasOwnProperty('ttmb_search_location'))
					{
						
						if(Object.keys(products).length == 1)
						{
							var page_title = '<header class="search-results-header"><div class="page-width search-results cloud-search-header"><h1 class="search-hero__title">There is ' + Object.keys(products).length + ' result within ' + sessionStorage.getItem('ttmb_distance') + ' miles of "' + sessionStorage.getItem('ttmb_search_location').split(',')[0] + '"</h1></div></header>';
						} else {
							var page_title = '<header class="search-results-header"><div class="page-width search-results cloud-search-header"><h1 class="search-hero__title">There are ' + Object.keys(products).length + ' results within ' + sessionStorage.getItem('ttmb_distance') + ' miles of "' + sessionStorage.getItem('ttmb_search_location').split(',')[0] + '"</h1></div></header>';
						}
						
						var original_title = $('.section-header');
						
						original_title.empty();
						
						$(page_title).appendTo(original_title);
					
					}
				
				}
				
			}
			
			if(self.get_type() == 'search' || self.get_type() == 'stockists')
			{
			
				// Add search by Keyup
			  
				self.stockist_search(features, map);
			
			}
			
		},
		
		set_all_features : function(dataset_endpoint = '', mapbox_data = '')
		{
			
            var self = this;
			
			if(dataset_endpoint == '')
			{
				
				dataset_endpoint = 'https://api.mapbox.com/datasets/v1/' + self.username() + '/' + self.get_id() + '/features?access_token=' + self.public_access_token();
				
			}
			
			$.ajax({
				
				type: 'GET',
				url: dataset_endpoint, 
				
				success: function(data, textStatus, xhr)
				{
					
					var link_header = xhr.getResponseHeader('Link');
					
					// More data to capture so build it up in json string
					
					if(link_header !== null && ~link_header.indexOf('rel="next"'))
					{

						var next_endpoint = link_header.substring(
							link_header.lastIndexOf('<') + 1, 
							link_header.lastIndexOf('>')
						);
						
						if(mapbox_data == '')
						{
							
							mapbox_data = [];
							
						}
						
						next_endpoint = next_endpoint + '&access_token=' + self.public_access_token();
						mapbox_data.push(data.features);
						self.set_all_features(next_endpoint, mapbox_data);

					} else {
						
						// If there's no mapbox data collected then this is just a single request, if there is mapbox data collected then set the mapbox_data var instead.
						
						if(mapbox_data == '')
						{
							
							var features = data.features;
							// features.sort(self.sort_geojson('name'));
							// features.reverse();
							features.sort(function (a, b) {
								if (a.properties.name < b.properties.name)
									return -1;
								else if (a.properties.name > b.properties.name)
									return 1;
							});
							var singular_data = {type : 'FeatureCollection', features : features};
							self.storage('ttmb_features', JSON.stringify(singular_data), 'set');
							return self.renderer();
							
						} else {
							
							var features = $.map(mapbox_data, function(n)
							{
								
							   return n;
							   
							});
							
							// features.sort(self.sort_geojson('name'));
							// features.reverse();
							features.sort(function (a, b) {
								if (a.properties.name < b.properties.name)
									return -1;
								else if (a.properties.name > b.properties.name)
									return 1;
							});
							var collected_data = {type : 'FeatureCollection', features : features};
							self.storage('ttmb_features', JSON.stringify(collected_data), 'set');
							return self.renderer();
							
						}
						
					}
					
				},
				
				error: function(output) {
					
					console.log("Error in API call");
					
				}
				
			});			
			
		},
      
      	set_features : function(cached = false)
      	{ 
        
            var self             = this,
            	dataset_endpoint = 'https://api.mapbox.com/datasets/v1/' + self.username() + '/' + self.get_id() + '/features?access_token=' + self.public_access_token();
				
            if(cached)
            {
				
				// Set dataset ID in first instance and then fetch dataset
				
				if(!sessionStorage.hasOwnProperty('ttmb_dataset_id'))
				{
					
					self.storage('ttmb_dataset_id', self.get_id(), 'set');
				  
					$.getJSON(dataset_endpoint, function(data)
					{

						self.storage('ttmb_features', JSON.stringify(data), 'set');

					});
				
				}
				
				// Set features if their dataset IDs don't match
				
				if(sessionStorage.hasOwnProperty('ttmb_dataset_id') && self.get_id() !== sessionStorage.getItem('ttmb_dataset_id'))
				{
			
					$.getJSON(dataset_endpoint, function(data)
					{

						self.storage('ttmb_features', JSON.stringify(data), 'set');

					});
					
					// Set new Dataset ID
					
					self.storage('ttmb_dataset_id', self.get_id(), 'set');
				
				}
				
			} else {
				
				self.storage('ttmb_dataset_id', self.get_id(), 'set');
			  
				$.getJSON(dataset_endpoint, function(data)
				{

					self.storage('ttmb_features', JSON.stringify(data), 'set');

				});
				
			}
          
        },
		
      	set_features_by_id : function(dataset_id = "")
      	{ 
        
            var self             = this,
            	dataset_endpoint = 'https://api.mapbox.com/datasets/v1/' + self.username() + '/' + dataset_id + '/features?access_token=' + self.public_access_token();
				
			self.storage('ttmb_dataset_id', dataset_id, 'set');
		  
			$.getJSON(dataset_endpoint, function(data)
			{

				self.storage('ttmb_features', JSON.stringify(data), 'set');

			});
          
        },
		
      	get_features : function()
      	{ 
        
            var self             = this,
            	dataset_endpoint = 'https://api.mapbox.com/datasets/v1/' + self.username() + '/' + self.get_id() + '/features?access_token=' + self.public_access_token();
				
			$.getJSON(dataset_endpoint, function(data)
			{

				return data;

			});
          
        },
		
		get_all_features : function(dataset_endpoint = '', mapbox_data = '')
		{
			
            var self = this;
			
			if(dataset_endpoint == '')
			{
				
				dataset_endpoint = 'https://api.mapbox.com/datasets/v1/' + self.username() + '/' + self.get_id() + '/features?access_token=' + self.public_access_token();
				
			}
			
			$.ajax({
				
				type: 'GET',
				url: dataset_endpoint, 
				
				success: function(data, textStatus, xhr)
				{
					
					var link_header = xhr.getResponseHeader('Link');
					
					// More data to capture so build it up in json string
					
					if(link_header !== null && ~link_header.indexOf('rel="next"'))
					{

						var next_endpoint = link_header.substring(
							link_header.lastIndexOf('<') + 1, 
							link_header.lastIndexOf('>')
						);
						
						if(mapbox_data == '')
						{
							
							mapbox_data = [];
							
						}
						
						next_endpoint = next_endpoint + '&access_token=' + self.public_access_token();
						mapbox_data.push(data.features);
						self.get_all_features(next_endpoint, mapbox_data);

					} else {
						
						// If there's no mapbox data collected then this is just a single request, if there is mapbox data collected then set the mapbox_data var instead.
						
						if(mapbox_data == '')
						{
							
							var features = data.features;
							// features.sort(self.sort_geojson('name'));
							// features.reverse();
							features.sort(function (a, b) {
								if (a.properties.name < b.properties.name)
									return -1;
								else if (a.properties.name > b.properties.name)
									return 1;
							});
							var singular_data = {type : 'FeatureCollection', features : features};
							return singular_data;
							
						} else {
							
							var features = $.map(mapbox_data, function(n)
							{
								
							   return n;
							   
							});
							
							// features.sort(self.sort_geojson('name'));
							// features.reverse();
							features.sort(function (a, b) {
								if (a.properties.name < b.properties.name)
									return -1;
								else if (a.properties.name > b.properties.name)
									return 1;
							});
							var collected_data = {type : 'FeatureCollection', features : features};
							return collected_data;
							
						}
						
					}
					
				},
				
				error: function(output) {
					
					console.log("Error in API call");
					
				}
				
			});			
			
		},
		
		get_map_icon : function()
		{
			var self = this, 
				web_app_endpoint = self.get_endpoint_url();
			return web_app_endpoint + '/storage/media/ttmb-red-map-marker.png';
		},

		view_switcher : function()
		{
			var self = this,
				list_icon = '<svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m22 17.75c0-.414-.336-.75-.75-.75h-13.5c-.414 0-.75.336-.75.75s.336.75.75.75h13.5c.414 0 .75-.336.75-.75zm-18.25-2.75c.966 0 1.75.784 1.75 1.75s-.784 1.75-1.75 1.75-1.75-.784-1.75-1.75.784-1.75 1.75-1.75zm18.25-1.25c0-.414-.336-.75-.75-.75h-13.5c-.414 0-.75.336-.75.75s.336.75.75.75h13.5c.414 0 .75-.336.75-.75zm-18.25-3.75c.966 0 1.75.784 1.75 1.75s-.784 1.75-1.75 1.75-1.75-.784-1.75-1.75.784-1.75 1.75-1.75zm18.25-.25c0-.414-.336-.75-.75-.75h-13.5c-.414 0-.75.336-.75.75s.336.75.75.75h13.5c.414 0 .75-.336.75-.75zm-18.25-4.75c.966 0 1.75.784 1.75 1.75s-.784 1.75-1.75 1.75-1.75-.784-1.75-1.75.784-1.75 1.75-1.75zm18.25.75c0-.414-.336-.75-.75-.75h-13.5c-.414 0-.75.336-.75.75s.336.75.75.75h13.5c.414 0 .75-.336.75-.75z" fill-rule="nonzero"/></svg>',
				map_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17.492 15.432c-.433 0-.855-.087-1.253-.259l.467-1.082c.25.107.514.162.786.162.222 0 .441-.037.651-.11l.388 1.112c-.334.118-.683.177-1.039.177zm-10.922-.022c-.373 0-.741-.066-1.093-.195l.407-1.105c.221.081.451.122.686.122.26 0 .514-.05.754-.148l.447 1.09c-.382.157-.786.236-1.201.236zm8.67-.783l-1.659-.945.583-1.024 1.66.945-.584 1.024zm-6.455-.02l-.605-1.011 1.639-.981.605 1.011-1.639.981zm3.918-1.408c-.243-.101-.5-.153-.764-.153-.23 0-.457.04-.674.119l-.401-1.108c.346-.125.708-.188 1.075-.188.42 0 .83.082 1.217.244l-.453 1.086zm7.327-.163c-.534 0-.968.433-.968.968 0 .535.434.968.968.968.535 0 .969-.434.969-.968 0-.535-.434-.968-.969-.968zm-16.061 0c-.535 0-.969.433-.969.968 0 .535.434.968.969.968s.969-.434.969-.968c0-.535-.434-.968-.969-.968zm18.031-.832v6.683l-4 2.479v-4.366h-1v4.141l-4-2.885v-3.256h-2v3.255l-4 2.885v-4.14h-1v4.365l-4-2.479v-13.294l4 2.479v3.929h1v-3.927l4-2.886v4.813h2v-4.813l1.577 1.138c-.339-.701-.577-1.518-.577-2.524l.019-.345-2.019-1.456-5.545 4-6.455-4v18l6.455 4 5.545-4 5.545 4 6.455-4v-11.618l-.039.047c-.831.982-1.614 1.918-1.961 3.775zm2-8.403c0-2.099-1.9-3.801-4-3.801s-4 1.702-4 3.801c0 3.121 3.188 3.451 4 8.199.812-4.748 4-5.078 4-8.199zm-5.5.199c0-.829.672-1.5 1.5-1.5s1.5.671 1.5 1.5-.672 1.5-1.5 1.5-1.5-.671-1.5-1.5zm-.548 8c-.212-.992-.547-1.724-.952-2.334v2.334h.952z"/></svg>',
				html = '<div id="ttmb-view-switcher">',
				header = $('.section-header-wrap');

			html = html + '<ul>';
				html = html + '<li data-view="list">' + list_icon + '<span>List</span></li>';
				html = html + '<li data-view="map">' + map_icon + '<span>Map</span></li>';
				html = html + '<li id="ttmb-ttmb-view-switcher-radius-item"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M1.341 6.502c1.11-2.157 2.877-3.984 5.162-5.16l.766 1.848c-1.779.954-3.169 2.393-4.074 4.081l-1.854-.769zm5.93 14.302c-1.688-.904-3.126-2.294-4.08-4.074l-1.848.765c1.175 2.286 3.002 4.054 5.16 5.165l.768-1.856zm-4.845-5.921c-.584-1.932-.549-3.932.005-5.765l-1.856-.768c-.739 2.311-.782 4.852.003 7.299l1.848-.766zm5.925-14.306l.766 1.848c1.932-.583 3.933-.549 5.765.005l.77-1.855c-2.313-.74-4.853-.782-7.301.002zm8.378 2.619c1.688.905 3.126 2.294 4.079 4.073l1.848-.766c-1.176-2.285-3.002-4.052-5.159-5.163l-.768 1.856zm4.845 5.919c.584 1.933.549 3.933-.005 5.766l1.855.769c.74-2.311.782-4.853-.003-7.301l-1.847.766zm-.77 7.614c-.904 1.688-2.294 3.126-4.072 4.08l.766 1.848c2.285-1.176 4.052-3.003 5.162-5.16l-1.856-.768zm-5.92 4.845c-1.933.584-3.933.549-5.766-.005l-.77 1.856c2.312.739 4.853.782 7.301-.002l-.765-1.849z"/></svg><span id="ttmb-ttmb-view-switcher-radius"></span></li>';
			html = html + '</ul>';
			html = html + '</div>';
			$(html).appendTo(header);
			self.map_distance_switcher('#ttmb-ttmb-view-switcher-radius');

			if(sessionStorage.hasOwnProperty('ttmb_search_view'))
			{
				if(sessionStorage.getItem('ttmb_search_view') == 'list')
				{
					$('body').addClass('ttmb-search-view-list');
					$('li[data-view="list"]').addClass('ttmb-spvs-active');
				} else if(sessionStorage.getItem('ttmb_search_view') == 'map') {
					$('body').addClass('ttmb-search-view-map');
					$('li[data-view="map"]').addClass('ttmb-spvs-active');
				}
			} else {
				$('body').addClass('ttmb-search-view-list');
				$('li[data-view="list"]').addClass('ttmb-spvs-active');
			}

			$('#ttmb-view-switcher li:not("#ttmb-ttmb-view-switcher-radius-item")').on('click', function()
			{
				var view = $(this);
				if(view.attr('data-view') == 'list')
				{
					self.storage('ttmb_search_view', 'list', 'set');
				} else if(view.attr('data-view') == 'map') {
					self.storage('ttmb_search_view', 'map', 'set');
				}
				view.addClass('ttmb-spvs-active').siblings().removeClass('ttmb-spvs-active');
				location.reload();
			});
			
		},
		
		map_style_switcher : function()
		{
			
			var terrain_icon   = '<img src="' + "//www.treasuretrails.co.uk/cdn/shop/t/4/assets/terrain-icon_small.png?v=119539358119134233531625137418" + '" alt="Terrain View" />',
				satellite_icon = '<img src="' + "//www.treasuretrails.co.uk/cdn/shop/t/4/assets/satellite-icon_small.png?v=42565639949949423701625137353" + '" alt="Satellite View" />',
				map_target     = $('#mapbox-container');
				
				if(sessionStorage.hasOwnProperty('ttmb_active_filter'))
				{
					terrain_li = sessionStorage.getItem('ttmb_active_filter') == 'streets-v11' ? '<li class="ttmb-vs-active" data-style="streets-v11">' + terrain_icon + '<span>Terrain</span></li>' : '<li data-style="streets-v11">' + terrain_icon + '<span>Terrain</span></li>';
				} else {
					terrain_li     = '<li class="ttmb-vs-active" data-style="streets-v11">' + terrain_icon + '<span>Terrain</span></li>';
				}

				var satellite_li   = sessionStorage.hasOwnProperty('ttmb_active_filter') && sessionStorage.getItem('ttmb_active_filter') == 'satellite-streets-v11' ? '<li class="ttmb-vs-active" data-style="satellite-streets-v11">' + satellite_icon + '<span>Satellite</span></li>' : '<li data-style="satellite-streets-v11">' + satellite_icon + '<span>Satellite</span></li>',
				html           = '';
				
			html = html + '<ul class="ttmb-view-switcher">';
				html = html + terrain_li;
				html = html + satellite_li;
			html = html + '</ul>';
			
			if(map_target.length > 0)
			{
				
				$(html).appendTo(map_target);
				
			}
			
		},
		
		map_zoom : function(map)
		{
			var self       = this,
				map_target = $('#mapbox-container'),
				html = '<div class="ttmb-map-zoom"><span class="ttmb-map-zoom-in">+</span><span class="ttmb-map-zoom-out">-</span></div>';
			
			if(map_target.length > 0)
			{
				$(html).appendTo(map_target);
			}
			
			$('.ttmb-map-zoom span').on('click', function()
			{
				var zoom = $(this);
				
				if(zoom.hasClass('ttmb-map-zoom-in'))
				{
					map.zoomIn({duration: 1000});
				} else if(zoom.hasClass('ttmb-map-zoom-out')) {
					map.zoomOut({duration: 1000});
				}
			});
		},
		
		map_distance_switcher : function(target = '#mapbox-container')
		{
			
			var self       = this,
				map_target = $(target),
				html       = '';
				
			// Build HTML
				
			html = '<div class="ttmb-distance-switcher">';
			
				html = html + '<label id="ttmb-distance-before" for="ttmb_distance">Distance:</label>';
			
				html = html + '<select name="ttmb_distance">';
				
					html = html + '<option value="5">5</option>';
					html = html + '<option value="10">10</option>';
					html = html + '<option value="20">20</option>';
					html = html + '<option value="30">30</option>';
					html = html + '<option value="50">50</option>';
					html = html + '<option value="100">100</option>';
					html = html + '<option value="200">200</option>';
					html = html + '<option value="all">All</option>';
				
				html = html + '</select>';
				
				html = html + '<label id="ttmb-distance-after">miles</label>';
			
			html = html + '</div>';
			
			if(map_target.length > 0)
			{
				
				$(html).appendTo(map_target);
				
			}
			
			// Storage
			
			if(!sessionStorage.hasOwnProperty('ttmb_distance'))
			{
				
				self.storage('ttmb_distance', 30, 'set');
				
			}
			
			$('select[name="ttmb_distance"]').on('change', function()
			{
				if(this.value == 'all')
                {
                  	window.location.href = '/pages/trail-search/';
                } else {
                    self.storage('ttmb_distance', this.value, 'set');
                    location.reload();
                }
				
			});
			
			// Set active filter
			
			$('select[name="ttmb_distance"] option').each(function()
			{
				
				if(this.value == sessionStorage.getItem('ttmb_distance'))
				{
					
					$(this).prop('selected', true);
					
				}
				
			});
			
		},
		
		set_current_filters : function(features, is_search_page = false)
		{
			
			var enabled_tags = $('#mapbox-renderer').attr('data-filters').split(', ').sort(),
				current_filters = {};
			if(is_search_page)
			{
				
				$.each(features, function(product_id, feature)
				{
					$.each(feature.properties.product_tags, function(index, tag)
					{
						if($.inArray(tag, enabled_tags) !== -1)
						{
							current_filters[tag] = tag;
						}
					});
				});
			} else {
				features.forEach(function(feature)
				{
					$.each(feature.properties.product_tags, function(index, tag)
					{
						if($.inArray(tag, enabled_tags) !== -1)
						{
							current_filters[tag] = tag;
						}
					});
				});
			}
			return_filters = Object.keys(current_filters).map(function (key) { return current_filters[key]; });
			sessionStorage.setItem('ttmb_current_tags', JSON.stringify(return_filters));
			
		},
		
		get_geojson : function()
		{
			
			var self     = this,
				web_app_endpoint = self.get_endpoint_url(),
				endpoint = web_app_endpoint + '/storage/datasets/' + self.get_id() + '.geojson';
				
			$.ajax({

				type: 'GET',
				url: endpoint,
				dataType: 'json',
				crossDomain: true,

				success : function(data)
				{
					data.features.sort(function (a, b) {
						if(a.properties !== undefined && b.properties !== undefined) {
							if (a.properties.name < b.properties.name)
								return -1;
							else if (a.properties.name > b.properties.name)
								return 1;
						} else {
							return -1;
						}
					});
					if(self.get_type() == 'secondary')
					{
						self.set_current_filters(data.features);
					}
					return self.renderer(data);

				},

				error: function (jqXHR, exception)
				{
                
                  	var current_template = $('#shopify-section-collection-mapbox'),
                        fallback_template = $('#collection-template-fallback'),
                        trail_search = $('#trail-search');

                    if(trail_search.length > 0) {
                        $('#ttmb-filter-nav-toggle-outer').remove();
                        $('#mapbox-container').remove();
                        window.location.replace('/collections/all');
                    } else {
                    	current_template.remove();
                    	fallback_template.show();
                    }
					
					/*

					var error = '';

					if (jqXHR.status === 0) {
						error = 'Can\'t connect.\n Verify Network.';
					} else if (jqXHR.status == 404) {
						error = 'Requested page not found. [404]';
					} else if (jqXHR.status == 500) {
						error = 'Internal Server Error [500].';
					} else if (exception === 'parsererror') {
						error = 'Requested JSON parse failed.';
					} else if (exception === 'timeout') {
						error = 'Time out error.';
					} else if (exception === 'abort') {
						error = 'Ajax request aborted.';
					} else {
						error = 'Uncaught Error.\n' + jqXHR.responseText;
					}

					alert(error);
					
					*/

				},

			});
			
		},
		
		build_map_popup_content : function(feature, trails_nearby = false, query_page = false)
		{
			var self = this,
				html = '',
				product_desc  = $(feature.properties.description);
				
			if(sessionStorage.hasOwnProperty('ttmb_search_location'))
			{
				
				var full_location = sessionStorage.getItem('ttmb_search_location').split(',');
				
			} else {
				
				var full_location = null;
				
			}
			
			var current_path = window.location.pathname;
			
			if(current_path == '/')
			{
				trails_nearby = true;
				query_page = true;
				var lng = sessionStorage.getItem('ttmb_current_lng'),
					lat = sessionStorage.getItem('ttmb_current_lat');
			} else if(~current_path.indexOf('trail-search'))
			{
				query_page = true;
				var lng = sessionStorage.getItem('ttmb_search_lng'),
					lat = sessionStorage.getItem('ttmb_search_lat');
			} else if(~current_path.indexOf('collections'))
			{
				
			}
			
			if(lng !== undefined && lat !== undefined)
			{
			
				var to = [lng, lat],
					from = feature.geometry.coordinates,
					options = {
						units: 'miles'
					},
					distance = turf.distance(to, from, options);
				
			}

			html = html + '<div class="ttmb-new-popup-image"><a href="' + feature.properties.product_url + '">';
			
				html = html + '<img class="lazyload" data-src="' + feature.properties.product_image + '" alt="' + feature.properties.name + '">';
			
			html = html + '</a></div>';
		
			html = html + '<div class="ttmb-new-popup-content"><a href="' + feature.properties.product_url + '">';
		
				html = html + '<h3>' + feature.properties.name + '</h3>';
				
				if(feature.properties.product_type !== null)
				{
					html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + ' | ' + feature.properties.product_type + '</p>';
				} else {
					html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + '</p>';
				}
				
				if(feature.properties.product_reviews !== 'null')
				{
					var product_reviews = JSON.parse(feature.properties.product_reviews);
					if(product_reviews.avarage_rating !== null && product_reviews.reviews_count !== null)
					{
						html = html + self.build_reviews_html(feature.properties.product_id, product_reviews);
					}
				}
				
				if(feature.properties.product_subtitle)
				{
					html = html + '<p class="ttmb-popup-content-subtitle"><strong>' + feature.properties.product_subtitle + '</strong></p>';
				}
				
				if(feature.properties.product_description)
				{
					html = html + '<p class="ttmb-popup-content-desc">' + $.trim($(feature.properties.product_description).text()).substring(0, 110).split(' ').slice(0, -1).join(' ') + '...</p>';
				}

				if(feature.properties.product_price)
				{
					html = html + '<p class="ttmb-popup-content-price"><span>Only &pound;' + feature.properties.product_price + '</span><span class="tt-add-to-cart btn btn--small">Buy Now</span></p>';
				}
				
				if(query_page && distance !== undefined)
				{
					if(trails_nearby)
					{
						html = html + '<span class="ttmb-distance-to">' + distance.toFixed(1) + ' miles from completed Trail</span>';
					} else if(full_location !== null) {
						html = html + '<span class="ttmb-distance-to">' + distance.toFixed(1) + ' miles from ' + full_location[0] + '</span>';
					}
				}
				
				// html = html + '<p><a class="tt-add-to-cart btn btn--small" href="' + feature.properties.product_url + '">Buy Now</a></p>';
			
			html = html + '</a>';
			
			if(product_desc.hasClass('ttmb-feature-offline'))
			{
			
				html = html + '<div class="tempoffline"><p>Temporarily offline <a data-fancybox="" data-src="#' + feature.properties.product_id + '-offline-standard" href="javascript:;" class="why" aria-describedby="a11y-external-message">Why?</a></p><div style="display:none;" id="' + feature.properties.product_id + '-offline-standard"><div class="offlineTitle"><p class="h4 grid-view-item__title product-card__title">Why is ' + feature.properties.name + ' offline?</p></div><p>We\'re really sorry but this Trail is currently unavailable to buy. We\'re working hard to resolve this as quickly as possible, so please bear with us. If you would like to know more, please contact us, or why not try one of our other exciting adventures nearby?</p></div></div>';
			
			}
			
			html = html + '</div>';

			return html;
		},
		
		map_click_handlers : function(map)
		{
			
			var self = this;
			
			// Click and mouse handlers for popups
			
			map.on('click', self.get_id(), function(e)
			{
				
				const center = new mapboxgl.LngLat(e.lngLat.lng, e.lngLat.lat);
				map.setCenter(center);
				
				var coordinates = e.features[0].geometry.coordinates.slice();
				var description = e.features[0].properties.description;
              
                description = decodeURIComponent(escape(description));
				
				while(Math.abs(e.lngLat.lng - coordinates[0]) > 180)
				{
					
					coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
					
				}
				 
				new mapboxgl.Popup()
					.setLngLat(coordinates)
					.setHTML(description)
					.addTo(map);
					
				if(self.get_type() == 'trails_nearby')
				{
					dataLayer.push({'event': 'trails_nearby'});
				}

				// Adjust Pop Up Structure

				var target = $('.ttmb-popup-content');
				target.empty();
				target.addClass('ttmb-trail-result-inner');
				$(self.build_map_popup_content(e.features[0])).appendTo(target);
				
				/*
				
				var new_html = '';
				$('.ttmb-trail-result-inner').each(function()
				{
					var result = $(this),
						title = result.find('h3');
					
					if(title.text() == e.features[0].properties.name)
					{
						new_html = result.html();
					}
				});
				
				if(new_html !== '')
				{
					var target = $('.ttmb-popup-content');
					target.empty();
					target.addClass('ttmb-trail-result-inner');
					$(new_html).appendTo(target);
					$('<a class="tt-add-to-cart btn btn--small" href="' + e.features[0].properties.product_url + '">Buy Now</a>').appendTo('.ttmb-popup-content.ttmb-trail-result-inner > a:last');
				}
				
				*/

			});

			map.on('mouseenter', self.get_id(), function()
			{
				
				map.getCanvas().style.cursor = 'pointer';
			
			});

			map.on('mouseleave', self.get_id(), function()
			{
				
				map.getCanvas().style.cursor = '';
			
			});
			
			// Click Handler for Style Switcher
			
			$('.ttmb-view-switcher li').on('click', function()
			{
				
				var item  = $(this),
					style = $(this).data('style');
					
				$(item).siblings().removeClass('ttmb-vs-active');
				$(item).addClass('ttmb-vs-active');
				
				// Store current selection in Browser Cache
				self.storage('ttmb_active_filter', style, 'set');
				
				// Rebuild Map
				// self.build_map(self.get_type(), dataset);;
				
				// Reload page instead, rebuilding map heavily lags intermittently
				location.reload();
				
			});
			
		},
		
		miles_to_meter : function(i)
		{
			
			return i * 1609.344;
			
		},
		
		render_product_grid : function(features)
		{
			
			var target = $('#mapbox-product-grid');
			
			// target.find('#ttmb-tny-title').remove();
			
			var html   = '<h2 id="ttmb-tny-title">Other Trails within ' + sessionStorage.getItem('ttmb_distance') + ' miles of your completed Trail</h2><div id="ttmb-trails-near-you">';
			
			$.each(features, function(product_id, feature)
			{
				
				html = html + '<div class="ttmb-trail-item">';
				
					html = html + '<a href="' + feature.properties.product_url + '" target="_blank">';
				
						html = html + '<h3>' + feature.properties.name + '</h3>';
						html = html + '<p class="ttmb-trail-type-region">' + feature.properties.product_type + ' | ' + feature.properties.region + '</p>';
						html = html + '<span class="ttmb-distance-to">' + feature.properties.distance_to + ' miles from completed Trail</span>';
					
					html = html + '</a>';
				
				html = html + '</div>';
				
			});
			
			html = html + '</div>';
			
			target.find('#ttmb-trails-near-you').remove();
			
			$(html).appendTo($(target));
			
		},
		
		render_trail_results : function(features, show_title = false)
		{
			
			var self = this;
			var target = $('#mapbox-product-grid');
			var html   = '<div id="ttmb-trails-near-you">';
			
			if(sessionStorage.hasOwnProperty('ttmb_search_location'))
			{
				
				var full_location = sessionStorage.getItem('ttmb_search_location').split(',');
				
			} else {
				
				var full_location = null;
				
			}
			
			if(show_title)
			{

				var result_title = '<h2 class="ttmb-tny-title">Other Trails within ' + sessionStorage.getItem('ttmb_distance') + ' miles of your completed Trail</h2>';
				$(result_title).prependTo($('#mapbox-outer-container'));
				// $(document).find('#ttmb-tny-title').first().remove();

			}
			
			$('#mapbox-product-grid').empty();

            var feature_counter = 1;
			
			$.each(features, function(product_id, feature)
			{
				
				var product_desc  = $(feature.properties.description);

				if(product_desc.hasClass('ttmb-feature-offline'))
				{
					
				html = html + '<div class="ttmb-trail-item ttmb-trail-result" data-product-id="' + feature.properties.product_id + '" data-product-price="' + feature.properties.product_price + '" data-product-name="' + feature.properties.name + '"><div class="ttmb-trail-result-inner ttmb-feature-offline">';
					
				} else {
					
				html = html + '<div class="ttmb-trail-item ttmb-trail-result" data-product-id="' + feature.properties.product_id + '" data-product-price="' + feature.properties.product_price + '" data-product-name="' + feature.properties.name + '"><div class="ttmb-trail-result-inner">';	
					
				}

                    // if(feature_counter <= 4)
					// {

    					html = html + '<a class="ttmb-search-result-image" href="' + feature.properties.product_url + '">';
    					
    						html = html + '<img class="lazyload" data-src="' + feature.properties.product_image + '" alt="' + feature.properties.name + '">';
    					
    					html = html + '</a>';

                    // }
				
					html = html + '<a href="' + feature.properties.product_url + '">';
				
						html = html + '<h3>' + feature.properties.name + '</h3>';

						if(feature.properties.banner_text !== undefined && feature.properties.banner_text !== null)
						{
							html = html + feature.properties.banner_text;
						}
						
						if(feature.properties.product_type !== null)
						{
							html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + ' | ' + feature.properties.product_type + '</p>';
						} else {
							html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + '</p>';
						}
						
						if(show_title)
						{
							html = html + '<span class="ttmb-distance-to">' + feature.properties.distance_to + ' miles from completed Trail</span>';
						} else if(full_location !== null) {
							html = html + '<span class="ttmb-distance-to">' + feature.properties.distance_to + ' miles from ' + full_location[0] + '</span>';
						}
						
						if(feature.properties.product_reviews)
						{
							html = html + self.build_reviews_html(feature.properties.product_id, feature.properties.product_reviews);
						}
						
						/*

						if(feature.properties.product_subtitle)
						{
							html = html + '<p><strong>' + feature.properties.product_subtitle + '</strong></p>';
						}
						
						if(feature.properties.product_description)
						{
							html = html + '<p>' + $.trim($(feature.properties.product_description).text()).substring(0, 110).split(' ').slice(0, -1).join(' ') + '...</p>';
						}
						
						*/

						if(feature.properties.product_price)
						{
							html = html + '<p>Only &pound;' + feature.properties.product_price + '</p>';
						}
						
						html = html + '<span class="tt-add-to-cart btn btn--small">Buy Now</span>';
					
					html = html + '</a>';
				
				html = html + '</div>';
				
				if(product_desc.hasClass('ttmb-feature-offline'))
				{
				
					html = html + '<div class="tempoffline"><p>Temporarily offline <a data-fancybox="" data-src="#' + feature.properties.product_id + '-offline-standard" href="javascript:;" class="why" aria-describedby="a11y-external-message">Why?</a></p><div style="display:none;" id="' + feature.properties.product_id + '-offline-standard"><div class="offlineTitle"><p class="h4 grid-view-item__title product-card__title">Why is ' + feature.properties.name + ' offline?</p></div><p>We\'re really sorry but this Trail is currently unavailable to buy. We\'re working hard to resolve this as quickly as possible, so please bear with us. If you would like to know more, please contact us, or why not try one of our other exciting adventures nearby?</p></div></div>';
				
				}
				
				html = html + '</div>';

                feature_counter = feature_counter + 1;
				
			});
			
			html = html + '</div>';
			
			html = html + '<span class="ttmb-load-more">Load More</span>';
			
			target.find('#ttmb-trails-near-you').remove();
			
			$(html).appendTo($(target));
			
			self.load_more('.ttmb-trail-result', '.ttmb-load-more');
			
			trail_result = $(document.body).find('.ttmb-trail-result');
			
			trail_result.on('click', function()
			{
				var current_link = $(this),
					product_id = current_link.data('product-id'),
					product_price = current_link.data('product-price'),
					product_name = current_link.data('product-name');

				gtag("event", "view_item", {currency: "GBP", value: product_price, items: [{item_id: product_id, item_name: product_name, price: product_price, quantity: 1}]});
			});
			
		},
		
		render_collection_results : function(features)
		{
			
			var self = this;
			var target = $('#mapbox-product-grid');
			var html   = '<div id="ttmb-trails-near-you">';
			
			$('#mapbox-product-grid').empty();
			
			$.each(features, function(product_id, feature)
			{
				var product_desc  = $(feature.properties.description);

				if(product_desc.hasClass('ttmb-feature-offline'))
				{
					
				html = html + '<div class="ttmb-trail-item ttmb-trail-result" data-product-id="' + feature.properties.product_id + '" data-product-price="' + feature.properties.product_price + '" data-product-name="' + feature.properties.name + '"><div class="ttmb-trail-result-inner ttmb-feature-offline">';
					
				} else {
					
				html = html + '<div class="ttmb-trail-item ttmb-trail-result" data-product-id="' + feature.properties.product_id + '" data-product-price="' + feature.properties.product_price + '" data-product-name="' + feature.properties.name + '"><div class="ttmb-trail-result-inner">';	
					
				}

					html = html + '<a href="' + feature.properties.product_url + '">';
					
						html = html + '<img class="lazyload" data-src="' + feature.properties.product_image + '" alt="' + feature.properties.name + '">';
					
					html = html + '</a>';
				
					html = html + '<a href="' + feature.properties.product_url + '">';
				
						html = html + '<h3>' + feature.properties.name + '</h3>';

						if(feature.properties.banner_text !== undefined && feature.properties.banner_text !== null)
						{
							html = html + feature.properties.banner_text;
						}
              
						if(feature.properties.product_type !== null)
						{
							html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + ' | ' + feature.properties.product_type + '</p>';
						} else {
							html = html + '<p class="ttmb-trail-type-region">' + feature.properties.region + '</p>';
						}
						
						feature.properties.product_reviews = JSON.parse(feature.properties.product_reviews);
						if(feature.properties.product_reviews)
						{
							html = html + self.build_reviews_html(feature.properties.product_id, feature.properties.product_reviews);
						}
						
						/*

						if(feature.properties.product_subtitle)
						{
							html = html + '<p><strong>' + feature.properties.product_subtitle + '</strong></p>';
						}
						if(feature.properties.product_description)
						{
							html = html + '<p>' + $.trim($(feature.properties.product_description).text()).substring(0, 110).split(' ').slice(0, -1).join(' ') + '...</p>';
						}
						
						*/

						if(feature.properties.product_price)
						{
							html = html + '<p>Only &pound;' + feature.properties.product_price + '</p>';
						}
						
						// html = html + '<a class="tt-add-to-cart btn btn--small" href="' + feature.properties.product_url + '">Buy Now</a>';
						html = html + '<span class="tt-add-to-cart btn btn--small">Buy Now</span>';
					
					html = html + '</a>';
				
				html = html + '</div>';
				
				if(product_desc.hasClass('ttmb-feature-offline'))
				{
				
				html = html + '<div class="tempoffline"><p>Temporarily offline <a data-fancybox="" data-src="#' + feature.properties.product_id + '-offline-standard" href="javascript:;" class="why" aria-describedby="a11y-external-message">Why?</a></p><div style="display:none;" id="' + feature.properties.product_id + '-offline-standard"><div class="offlineTitle"><p class="h4 grid-view-item__title product-card__title">Why is ' + feature.properties.name + ' offline?</p></div><p>We\'re really sorry but this Trail is currently unavailable to buy. We\'re working hard to resolve this as quickly as possible, so please bear with us. If you would like to know more, please contact us, or why not try one of our other exciting adventures nearby?</p></div></div>';
				
				}
				
				html = html + '</div>';
				
			});
			
			html = html + '</div>';
			
			html = html + '<span class="ttmb-load-more">Load More</span>';
			
			target.find('#ttmb-trails-near-you').remove();
			
			$(html).appendTo($(target));
			
			self.load_more('.ttmb-trail-result', '.ttmb-load-more');
			
			trail_result = $(document.body).find('.ttmb-trail-result');
			
			trail_result.on('click', function()
			{
				var current_link = $(this),
					product_id = current_link.data('product-id'),
					product_price = current_link.data('product-price'),
					product_name = current_link.data('product-name');

				gtag("event", "view_item", {currency: "GBP", value: product_price, items: [{item_id: product_id, item_name: product_name, price: product_price, quantity: 1}]});
			});
			
		},
		
		build_reviews_html : function(product_id, data)
		{
			
			var html = '<p class="ratingStars"><span class="spr-badge" id="spr_badge_' + product_id + '" data-rating="' + data.avarage_rating + '"><span class="spr-starrating spr-badge-starrating">';
			
			if(Number.isInteger(data.avarage_rating))
			{

				for(var i = 0, l = data.avarage_rating; i < l; i++)
				{
					
					html = html + '<i class="spr-icon spr-icon-star"></i>';

				}
				
				var empty_count = 5 - data.avarage_rating;
				
				if(empty_count > 0)
				{
					
					for(var i = 0, l = empty_count; i < l; i++)
					{
						
						html = html + '<i class="spr-icon spr-icon-star-empty"></i>';

					}					
					
				}
				
			} else {
				
				var float_string = '' + data.avarage_rating,
					star_count   = Math.round(data.avarage_rating),
					final_star   = '0.' + float_string.split('.')[1],
					final_star   = parseFloat(final_star);
					
				for(var i = 0, l = data.avarage_rating; i < l; i++)
				{
					
					if(i == star_count)
					{
						
						if(final_star >= 0.5)
						{
							
							html = html + '<i class="spr-icon spr-icon-star"></i>';
							
						} else {
							
							html = html + '<i class="spr-icon spr-icon-star-half-alt"></i>';
							
						}
						
					} else {
					
						html = html + '<i class="spr-icon spr-icon-star"></i>';
					
					}
					
				}
				
				var empty_count = 4 - Math.floor(data.avarage_rating);
				
				if(empty_count > 0)
				{
					
					for(var i = 0, l = empty_count; i < l; i++)
					{
						
						html = html + '<i class="spr-icon spr-icon-star-empty"></i>';

					}					
					
				}
				
			}
			
			html = html + '</span>';
			
			if(data.reviews_count)
			{
			
				html = html + '<span class="spr-badge-caption">' + data.reviews_count + ' reviews</span>';
			
			}
			
			html = html + '</span></p>';
			
			return html;

		},
		
		build_select : function(select_name, options, select_first_option)
		{
			
			var select = '<select name="' + select_name + '" required>';
			
			select = select + '<option value="">' + select_first_option + '</option>';
			
			$.each(options, function(key, value)
			{
				
				if(value !== '' && value !== null)
				{
					select = select + '<option value="' + key + '">' + value.replace(' | ', ' ') + '</options>';
				}
				
			});
			
			var select = select + '</select>';
			
			return select;
			
		},
		
		get_customer_data: function()
		{
			const self = this;
			const web_app_endpoint = self.get_endpoint_url();
			const webhook_endpoint = `${web_app_endpoint}/webhook/answer-submission`;
			const request_data = sessionStorage.getItem('ttmb_submission_data');

			window.addEventListener('beforeunload', function () {
				const data = sessionStorage.getItem('ttmb_submission_data');
				if (data && !sessionStorage.getItem('ttmb_submission_complete')) {
					navigator.sendBeacon(webhook_endpoint, new Blob([data], {type: 'application/json'}));
				}
			});
		  
			$(self.loader()).appendTo('body');
		  
			$.ajax({
			  type: 'POST',
			  url: webhook_endpoint,
			  crossDomain: true,
			  data: request_data,
			  dataType: 'json',
			  contentType: 'application/json',
			  timeout: 120000, // 2 minutes instead of waiting forever
		  
			  success: function (data) {
				if (data && Object.keys(data).length > 0) {
				  sessionStorage.setItem('ttmb_answer_data', JSON.stringify(data));
				  sessionStorage.setItem('ttmb_submission_complete', 'true');
		  
				  $('#ttmb-answer-form').fadeOut(function () {
					location.reload(); // Safe to reload now
				  });
				} else {
				  alert("Submission complete, but we couldn't verify the response. Please try again later.");
				  $('.ttmb-loader').remove();
				}
			  },
		  
			  error: function (jqXHR, exception) {
				$('.ttmb-loader').remove();
		  
				const errorMsg = {
				  0: "Can't connect. Verify network.",
				  404: "Requested page not found. [404]",
				  500: "Internal Server Error [500]",
				}[jqXHR.status] || {
				  parsererror: "Requested JSON parse failed.",
				  timeout: "Timeout error.",
				  abort: "Ajax request aborted.",
				}[exception] || `Uncaught Error: ${jqXHR.responseText}`;
		  
				alert(errorMsg);
			  }
			});
		},  
		
		answer_video : function(video_to_return = 'treasure_correct')
		{
			var videos = {
				treasure_correct: 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Treasure-Correct.mp4',
				treasure_incorrect: 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Treasure-Incorrect.mp4',
				spy_correct: 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Spy-Correct.mp4',
				spy_incorrect: 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Spy-Incorrect.mp4',
				detective_correct: 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Detective-Correct.mp4',
				detective_incorrect: 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Detective-Incorrect.mp4'
			};
			return '<video playsinline id="ttmb-answer-video"><source src="' + videos[video_to_return] + '" type="video/mp4"></video>';
		},
		
		answer_video_handler : function(dataset)
		{
			var self = this;
			const answerVideo = document.getElementById('ttmb-answer-video');
			const playPromise = answerVideo.play() || Promise.reject('');
			
			playPromise.then(() => {
			}).catch(err => {
				answerVideo.muted = true;
				answerVideo.controls = true;
				answerVideo.play();
			});
			
			answerVideo.addEventListener('play', (event) => {
				$('html, body').animate({
					scrollTop: $('#ttmb-submission-result').offset().top - 30
				}, 500);
				setTimeout(function()
				{
					$('#ttmb-submission-content-reveal').slideDown(function()
					{
						$('#mapbox-outer-container').slideDown(function()
						{
							self.build_map(self.get_type(), dataset);
						});
					});
				}, 6000);
			});
			answerVideo.addEventListener('ended', (event) => {
                $('html, body').animate({
                  	scrollTop: $('#ttmb-submission-content-reveal').offset().top - 30
                }, 500);
			});
		},
		
		urn_form : function()
		{
			
			// Flush out all data
			
			sessionStorage.removeItem('ttmb_submission_urn');
			sessionStorage.removeItem('ttmb_submission_rating');
			sessionStorage.removeItem('ttmb_submission_data');
			sessionStorage.removeItem('ttmb_submission_first_name');
			sessionStorage.removeItem('ttmb_answer_data');
			sessionStorage.removeItem('ttmb_dataset_id');
			sessionStorage.removeItem('ttmb_features');
			sessionStorage.removeItem('ttmb_distance');
			sessionStorage.removeItem('ttmb_search_geo');
			sessionStorage.removeItem('ttmb_search_location');
			sessionStorage.removeItem('ttmb_search_lat');
			sessionStorage.removeItem('ttmb_search_lng');
			sessionStorage.removeItem('ttmb_trail_results');
			sessionStorage.removeItem('ttmb_submission_complete');
			
			// Target / Build URN Form
			
			var self     = this,
				target   = $('#ttmb-forms'),
				urn_form = '<form id="ttmb-urn-form" class="ttmb-form" method="post">';
				urn_form = urn_form + '<input type="text" name="urn" placeholder="Enter Trail URN..." required>';
				urn_form = urn_form + '<input type="submit" value="Next">';
				urn_form = urn_form + '</form>';
				
			target.empty();
				
			$(urn_form).appendTo(target);
			
			// URN Form Click Handler / AJAX Requested
			
			$('#ttmb-urn-form').submit(function(form)
			{
		
				form.preventDefault();
				
				var webhook_endpoint = self.get_pdf_endpoint_url() + '/api/urn';
					
				$.ajax({

					type: 'POST',
					url: webhook_endpoint,
					crossDomain: true,
					data: $(this).serialize(),
					dataType: 'json',

					success : function(data) 
					{

						self.answer_form(data);

					},

					error: function (jqXHR, exception)
					{

						var error = '';

						if (jqXHR.status === 0) {
							error = 'Can\'t connect.\n Verify Network.';
						} else if (jqXHR.status == 404) {
							error = 'Requested page not found. [404]';
						} else if (jqXHR.status == 500) {
							error = 'Internal Server Error [500].';
						} else if (exception === 'parsererror') {
							error = 'Requested JSON parse failed.';
						} else if (exception === 'timeout') {
							error = 'Time out error.';
						} else if (exception === 'abort') {
							error = 'Ajax request aborted.';
						} else {
							error = 'Uncaught Error.\n' + jqXHR.responseText;
						}

						alert(error);

					},

				});
		
			});
			
		},
		
		answer_form : function(data)
		{
			if (sessionStorage.getItem('ttmb_submission_complete') === 'true') {
				$('#ttmb-forms').html('<p><strong>Your answer has already been submitted successfully.</strong></p>');
				return;
			}
			
			// Target / Build Answer Form
			
			var self        = this,
				target      = $('#ttmb-forms'),
				answer_form = '<form id="ttmb-answer-form" class="ttmb-form" method="post">';
				
			if(data.success !== false)
			{
				
				if(data.parent_name !== undefined)
				{
					
					answer_form = answer_form + '<h3>' + data.parent_name.replace(/([\[\]\{\}\"])+/g, '') + '</h3>';
				
				}
				
				if(data.parent_type !== '' && data.parent_type !== null && data.parent_type !== undefined)
				{
					
					var trail_type = data.parent_type;
					
				} else {
					
					var trail_type = '';
					
				}
					
				if(data.parent_type == 'spy')
				{
					
					answer_form = answer_form + '<label for="cypher">Shaken But Not Stirred, I\'ve Cracked This One. The Code Is...</label>';
					answer_form = answer_form + '<div class="ttmb-form-input-row">';
					answer_form = answer_form + '<input class="ttmb-cypher" name="cipher[]" type="text" minlength="1" maxlength="1" required><input class="ttmb-cypher" name="cipher[]" type="text" minlength="1" maxlength="1" required><input class="ttmb-cypher" name="cipher[]" type="text" minlength="1" maxlength="1" required><input class="ttmb-cypher" name="cipher[]" type="text" minlength="1" maxlength="1" required>';
					answer_form = answer_form + '</div>';
					
				} else if(data.parent_type == 'treasure') {
					
					answer_form = answer_form + '<label for="location_id">The Treasure Is Buried At...</label>';
					answer_form = answer_form + '<div class="ttmb-form-input-row">';
					answer_form = answer_form + self.build_select('location_id', data.options, 'Select Location');
					answer_form = answer_form + '</div>';
					
				} else if(data.parent_type == 'murder' || data.parent_type == 'detective') {
					
					answer_form = answer_form + '<label for="suspect_id">Step Aside Sherlock, The Guilty Party Is...</label>';
					answer_form = answer_form + '<div class="ttmb-form-input-row">';
					answer_form = answer_form + self.build_select('suspect_id', data.options.suspects, 'Select Suspect');
					answer_form = answer_form + '</div>';
					answer_form = answer_form + '<label for="weapon_id">And I\'m Sure They Used The Following Weapon...</label>';
					answer_form = answer_form + '<div class="ttmb-form-input-row">';
					answer_form = answer_form + self.build_select('weapon_id', data.options.weapons, 'Select Weapon');
					answer_form = answer_form + '</div>';
					
				}
					
				answer_form = answer_form + '<label>Your Details / How would you rate this trail?</label>';
				answer_form = answer_form + '<div class="ttmb-form-input-row">';
				answer_form = answer_form + '<input type="email" name="email" placeholder="Email Address..." required>';
				answer_form = answer_form + '<input type="text" name="first_name" placeholder="First Name..." required>';
				answer_form = answer_form + '<select name="rating" type="text" placeholder="Trail Rating..." required><option value="" selected="">Trail Rating...</option><option value="10">10 - Amazing day out</option><option value="9">9 - We all gave it a thumbs up</option><option value="8">8 - Great fun with room for improvement</option><option value="7">7 - Fun, even with some problems</option><option value="6">6 - Like the concept but missed the mark</option><option value="5">5 - Could have been way better</option><option value="4">4 - Not impressed</option><option value="3">3 - Waste of money</option><option value="2">2 - Never again</option><option value="1">1 - Complete disaster</option></select>';
				answer_form = answer_form + '</div>';
				answer_form = answer_form + '<label>We are passionate about our Trails and would love to know any other feedback you have which will help us improve the trail.</label><textarea name="feedback" placeholder="Feedback..."></textarea>';
				answer_form = answer_form + '<label>Sometimes, clues can be moved, blocked or cannot be solved for many reasons. Any information you can provide will help us fix the problem as soon as possible and be sincerely appreciated by all the team. Thank you!</label><textarea name="issues" placeholder="Issues..."></textarea>';
				
				if(data.urn !== undefined)
				{
					
					answer_form = answer_form + '<input type="hidden" name="urn" value="' + data.urn + '">';
					self.storage('ttmb_submission_urn', data.urn, 'set');
				
				}
              
                answer_form = answer_form + '<p>By submitting your answer you agree to our <a href="https://www.treasuretrails.co.uk/pages/prize-rules" target="_blank">Prize Draw Terms</a> and our <a href="https://www.treasuretrails.co.uk/pages/privacy" target="_blank">Privacy Policy</a> and agree to us contacting you from time to time with amazing offers, details of Trails, competitions and more. You can at any time request these communications to stop.</p>';
				
				answer_form = answer_form + '<input id="pltt-submit-answer" type="submit" value="Answer">';
			
			} else {
				
				if(data.error !== '' || data.error !== undefined)
				{
					
					answer_form = answer_form + '<p class="pltt-answer-form-error">' + data.error + '</p>';
					
				}
				
				answer_form = answer_form + '<span id="ttmb-clear-submission">Enter new URN</span>';
				
			}
			
			answer_form = answer_form + '</form>';
			
			// Switch Forms
				
			$(answer_form).appendTo(target).hide();
			
			target.find('#ttmb-urn-form').fadeOut(function()
			{
				
				target.find('#ttmb-answer-form').fadeIn();
				
			});
			
			// Automatically go to next Cypher Field

			$('#ttmb-answer-form .ttmb-cypher').keyup(function()
			{
				
				if(this.value.length == this.maxLength)
				{
					
					$(this).next('.ttmb-cypher').focus();

				}
				
			});
			
			// Click handler for URN reset
			
			$('#ttmb-clear-submission').click(function()
			{
				
				sessionStorage.removeItem('ttmb_submission_urn');
				sessionStorage.removeItem('ttmb_submission_rating');
				sessionStorage.removeItem('ttmb_submission_data');
				sessionStorage.removeItem('ttmb_submission_first_name');
				sessionStorage.removeItem('ttmb_answer_data');
				sessionStorage.removeItem('ttmb_dataset_id');
				sessionStorage.removeItem('ttmb_features');
				sessionStorage.removeItem('ttmb_distance');
				sessionStorage.removeItem('ttmb_search_geo');
				sessionStorage.removeItem('ttmb_search_location');
				sessionStorage.removeItem('ttmb_search_lat');
				sessionStorage.removeItem('ttmb_search_lng');
				sessionStorage.removeItem('ttmb_trail_results');
				location.reload();
				
			});
			
			// Answer Form Click Handler / AJAX Requested
			
			$('#ttmb-answer-form').submit(function(form)
			{
		
				form.preventDefault();
				var form_button = $(form).find('input[type="submit"]');
				form_button.prop('disabled', true);
				
				// Now, store the rating in sessionStorage
				
				var rating = $(this).find('select[name="rating"] option:selected').val();
				
				if(rating)
				{
					sessionStorage.setItem('ttmb_submission_rating', rating);
				}
				
				var first_name = $(this).find('input[name="first_name"]').val();
				
				if(first_name)
				{
					sessionStorage.setItem('ttmb_submission_first_name', first_name);
				}
				
				var webhook_endpoint = self.get_pdf_endpoint_url() + '/api/answer';

				if (!window.__PushLogicAjaxHandlerASInitialized) {
					window.__PushLogicAjaxHandlerASInstance = new PushLogicAjaxHandler();
					window.__PushLogicAjaxHandlerASInitialized = true;
				}
					
				$.ajax({

					type: 'POST',
					url: webhook_endpoint,
					crossDomain: true,
					data: $(this).serialize(),
					dataType: 'json',

					success : function(data) 
					{
						
						// Add Rating from sessionStorage to submission data
						
						if(sessionStorage.hasOwnProperty('ttmb_submission_rating'))
						{
							data.rate = sessionStorage.getItem('ttmb_submission_rating');
						}
						
						// Add URN from sessionStorage to submission data
						
						if(sessionStorage.hasOwnProperty('ttmb_submission_urn'))
						{
							data.urn = sessionStorage.getItem('ttmb_submission_urn');
						}
						
						// Add First Name from sessionStorage to submission data
						
						if(sessionStorage.hasOwnProperty('ttmb_submission_first_name'))
						{
							data.first_name = sessionStorage.getItem('ttmb_submission_first_name');
						}
						
						// Add access key to submission data
						
						data.access_key = '2s5v8y/B?E(H+MbQeThWmZq4t6w9z$C&F)J@NcRfUjXn2r5u8x!A%D*G-KaPdSgV';
						
						self.storage('ttmb_submission_data', JSON.stringify(data), 'set');
						
						if(trail_type !== '')
						{
						
							self.storage('ttmb_submission_type', trail_type, 'set');
						
						}

						jQuery(document).ready(function($) {
							(function waitForSignature() {
							  const handler = window.__PushLogicAjaxHandlerASInstance;
						  
							  if (handler?.secureToken?.signature) {
								self.get_customer_data();
							  } else {
								setTimeout(waitForSignature, 100);
							  }
							})();
						});
						
						form_button.prop('disabled', false);
						
						$("<script>window.dataLayer = window.dataLayer || [];dataLayer.push({'event': 'answer_submission_success'});</script>").appendTo('head');
						sessionStorage.setItem('pltt_post_answer_submit', 'active');

					},

					error: function (jqXHR, exception)
					{

						var error = '';

						if (jqXHR.status === 0) {
							error = 'Can\'t connect.\n Verify Network.';
						} else if (jqXHR.status == 404) {
							error = 'Requested page not found. [404]';
						} else if (jqXHR.status == 500) {
							error = 'Internal Server Error [500].';
						} else if (exception === 'parsererror') {
							error = 'Requested JSON parse failed.';
						} else if (exception === 'timeout') {
							error = 'Time out error.';
						} else if (exception === 'abort') {
							error = 'Ajax request aborted.';
						} else {
							error = 'Uncaught Error.\n' + jqXHR.responseText;
						}

						alert(error);
						form_button.prop('disabled', false);

					},

				});
		
			});
			
		},
		
		create_table : function(data)
		{
			
			var self = this,
                counter = 1;

			if(data)
			{
				
				$html = '<table class="ttmb-clues-result responsive-table">';
				$html = $html + '<tr><th>Clue #</th><th>Answer</th><th>Detail</th></tr>';
				
				$.each(self.sort_data('sequence', data, 'asc'), function(key, value)
				{

					if(value['answer'] !== '' && value['answer_detail'] !== '' && value['answer'] !== null && value['answer_detail'] !== null && value['type'] == 'clue' || value['type'] == 'sponsor')
					{
						
						if(value['sponsor'] !== '')
						{
							var sponser_details = '<small>' + value['sponsor'] + '</small>';
						} else {
							var sponser_details = '';
						}
						
						$html = $html + '<tr>';
						
						if(value['type'] == 'sponsor')
						{
							$.each(value, function(key, value)
							{
							  
								if(key == 'sequence')
								{
								  
									$html = $html + '<td>' + counter + '</td>';
								  
								} else if(key == 'answer')
								{
									
									$html = $html + '<td>' + value + '</td>';
									
								} else if(key == 'answer_detail')
								{
									
									$html = $html + '<td>' + value + sponser_details + '</td>';
									
								}
								
							});	
						} else {
							$.each(value, function(key, value)
							{
							  
								if(key == 'sequence')
								{
								  
									$html = $html + '<td>' + counter + '</td>';
								  
								} else if(key == 'answer' || key == 'answer_detail')
								{
									
									$html = $html + '<td>' + value + '</td>';
									
								}
								
							});	

						}
						
						$html = $html + '</tr>';
                      	counter = counter + 1;
                      	
					
					}
					
				});
				
				$html = $html + '</table>';
				
				return $html;
				
			}	
			
		},
		
		submission_result : function(dataset)
		{
			
			var self       = this,
				target     = $('#ttmb-forms'),
				result     = JSON.parse(sessionStorage.getItem('ttmb_submission_data')),
				trail_type = sessionStorage.getItem('ttmb_submission_type'),
				html       = '';
				
			target.empty();
				
			if(result.storage.contact_answer_correct !== undefined && result.storage.contact_answer_correct === true)
			{
				
				html = html + '<div id="ttmb-submission-result" class="ttmb-sr-success">';
				
				if(trail_type == 'spy')
				{
					
					var success_title = 'You\'ve saved the day!',
						success_text  = 'saved the day',
						child_title   = 'Mini Agent',
						plural_name   = 'Agents',
						answer_text   = 'The de-activation code is ',
						cert          = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Spy-Mission-Certificate.pdf?v=1614809849',
						club          = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/mini-secret-agent-club-complete.pdf?v=1617100063',
						answer        = result.storage.trail_answer,
						video         = self.answer_video('spy_correct');
					
				} else if(trail_type == 'treasure') {
					
					var success_title = 'Treasure Found!',
						success_text  = 'discovered the correct location',
						child_title   = 'young Explorer',
						plural_name   = 'Explorers',
						answer_text   = 'The treasure was hidden at ',
						cert          = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Treasure-Hunt-Certificate.pdf?v=1614809849',
						club          = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/mini-explorer-club-complete.pdf?v=1617100060',
						answer        = result.storage.trail_answer,
						video         = self.answer_video('treasure_correct');
						
				} else if(trail_type == 'detective' || trail_type == 'murder') {
					
					var success_title = 'Case Closed!',
						success_text  = 'solved the case',
						child_title   = 'young Detective',
						plural_name   = 'Detectives',
						answer_text   = 'The culprit and evidence is ',
						cert          = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Detective-Mystery-Certificate.pdf?v=1614809849',
						club          = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/mini-detective-club-complete.pdf?v=1617100060',
						answer        = result.storage.trail_answer + ' with ' + result.storage.trail_weapon,
						video         = self.answer_video('detective_correct');
						
				}
				
				html = html + video;
				
				html = html + '<div id="ttmb-submission-content-reveal">';

                html = html + '<section class="ttmb-submission-section">';
				
				// html = html + '<p><span class="btn ttmb-submission-map-scroll">Your Next Adventure</span></p>';	
                html = html + '<p><span class="btn ttmb-submission-data-reveal">View Trail Answers</span></p>';

                html = html + '</section>';

                html = html + '<section class="ttmb-submission-section">';

                html = html + '<p>Many thanks for submitting your feedback - one of our team will reply to you in a couple of days. Now check out the below:</p>';

                html = html + '</section>';

                html = html + '<section class="ttmb-submission-section">';

				html = html + '<h3 id="ttmb-submission-success">' + success_title + '</h3>';
				
				html = html + '<p>Thanks for submitting your answer and letting us know how you got on. Not only have you ' + success_text + ' but you\'ve also been entered into a £100 monthly prize draw!</p>';
				
				// html = html + '<p>If you have a ' + child_title + ', you can get their <a href="' + club + '" target="_blank">Sneaky Sleuthing Skills Badges and invite to their next adventure here</a> and for ' + plural_name + ' big and small, <a href="' + cert + '" target="_blank">your Trail certificate can be downloaded here</a>.</p>';
				
				// html = html + '<p><strong>Please click below to show the Trail answer and clue details</strong></p>';

                html = html + '</section>';

				html = html + '<div id="ttmb-submission-answer-data">';

                html = html + '<section class="ttmb-submission-section">';
				
				html = html + '<h4>The answers to your Treasure Trail</h4>';
				
				if(result.answer !== undefined)
				{
					
					html = html + '<h5 id="ttmb-submission-status">' + answer_text + answer + '</h5>';
					
				}
				
				if(result.clues !== undefined)
				{
					
					html = html + self.create_table(result.clues);
					
				}

                html = html + '</section>';
				
				html = html + '</div>';
				
			} else if(result.storage.contact_answer_correct !== undefined && result.storage.contact_answer_correct === false || result.storage.contact_answer_correct !== undefined && result.storage.contact_answer_correct !== '') {
				
				html = html + '<div id="ttmb-submission-result" class="ttmb-sr-fail">';
				
				if(trail_type == 'spy')
				{
					
					var fail_title  = 'Super Close Agent!',
						fail_text   = 'saved the day',
						child_title = 'Mini Agent',
						plural_name = 'Agents',
						answer_text = 'The de-activation code is ',
						cert        = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Spy-Mission-Certificate.pdf?v=1614809849',
						club        = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/mini-secret-agent-club-complete.pdf?v=1617100063',
						answer      = result.storage.trail_answer,
						video       = self.answer_video('spy_incorrect');
						
				} else if(trail_type == 'treasure') {
					
					var fail_title  = 'Super Close Explorer!',
						fail_text   = 'discovered the correct location',
						child_title = 'young Explorer',
						plural_name = 'Explorers',
						answer_text = 'The treasure was hidden at ',
						cert        = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Treasure-Hunt-Certificate.pdf?v=1614809849',
						club        = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/mini-explorer-club-complete.pdf?v=1617100060',
						answer      = result.storage.trail_answer,
						video       = self.answer_video('treasure_incorrect');
						
				} else if(trail_type == 'detective' || trail_type == 'murder') {
					
					var fail_title  = 'Super Close Detective!',
						fail_text   = 'solved the case',
						child_title = 'young Detective',
						plural_name = 'Detectives',
						answer_text = 'The culprit and evidence is ',
						cert        = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/Detective-Mystery-Certificate.pdf?v=1614809849',
						club        = 'https://cdn.shopify.com/s/files/1/0298/3968/7725/files/mini-detective-club-complete.pdf?v=1617100060',
						answer      = result.storage.trail_answer + ' with ' + result.storage.trail_weapon,
						video       = self.answer_video('detective_incorrect');
						
				}
				
				html = html + video;
				
				html = html + '<div id="ttmb-submission-content-reveal">';

                html = html + '<section class="ttmb-submission-section">';
				
				// html = html + '<p><span class="btn ttmb-submission-map-scroll">Your Next Adventure</span></p>';		
                html = html + '<span class="btn ttmb-submission-data-reveal">View Trail Answers</span>';

                html = html + '</section>';

                html = html + '<section class="ttmb-submission-section">';

                html = html + '<p>Many thanks for submitting your feedback - one of our team will reply to you in a couple of days. Now check out the below:</p>';

                html = html + '</section>';

                html = html + '<section class="ttmb-submission-section">';
				
				html = html + '<h3 id="ttmb-submission-fail">' + fail_title + '</h3>';
				
				html = html + '<p>Thanks for submitting your answer and letting us know how you got on. We\'re sorry but you haven\'t entered the correct answer on this occasion. Don\'t worry though, as your help and hard work hasn\'t gone unnoticed!</p>';
				
				// html = html + '<p><strong>Please click below to show the Trail answer and clue details</strong></p>';

                html = html + '</section>';
				
				html = html + '<div id="ttmb-submission-answer-data">';

                html = html + '<section class="ttmb-submission-section">';
				
				html = html + '<h4>The answers to your Treasure Trail</h4>';
				
				if(result.answer !== undefined)
				{
					
					html = html + '<h5 id="ttmb-submission-status">' + answer_text + answer + '</h5>';
					
				}
				
				if(result.clues !== undefined)
				{
					
					html = html + self.create_table(result.clues);
					
				}

                html = html + '</section>';
				
				html = html + '</div>';

			}

            html = html + '<section class="ttmb-submission-section">';
			
			html = html + '<p><strong>Check out the Trail Blazer Badges you have unlocked:</strong></p>';
			
			html = html + '<p><a class="btn" href="/account">Trail Blazer Status</a></p>';
			
			html = html + '<p>If you have a ' + child_title + ', you can get their <a href="' + club + '" target="_blank">Sneaky Sleuthing Skills Badges and invite to their next adventure here</a> and for ' + plural_name + ' big and small, <a href="' + cert + '" target="_blank">your Trail certificate can be downloaded here</a>.</p>';

            html = html + '</section>';

            html = html + '<section class="ttmb-submission-section">';
          
			html = html + '<p><strong>Have another Trail answer to submit?</strong></p>';
				
			html = html + '<p><span class="btn" id="ttmb-clear-submission">Enter URN</span></p>';

            html = html + '</section>';
			
			// html = html + '<p id="ttmb-trails-nearby"><strong>Other Trails close to your submission</strong></p>';
			
			html = html + '</div></div>';
			
			$(html).appendTo(target);
			
			self.answer_video_handler(dataset);
			
			$('#ttmb-clear-submission').click(function()
			{
				
				sessionStorage.removeItem('ttmb_submission_data');
				sessionStorage.removeItem('ttmb_submission_type');
				sessionStorage.removeItem('ttmb_submission_urn');
				sessionStorage.removeItem('ttmb_submission_first_name');
				sessionStorage.removeItem('ttmb_submission_rating');
				sessionStorage.removeItem('ttmb_answer_data');
				sessionStorage.removeItem('ttmb_dataset_id');
				sessionStorage.removeItem('ttmb_features');
				sessionStorage.removeItem('ttmb_distance');
				sessionStorage.removeItem('ttmb_search_geo');
				sessionStorage.removeItem('ttmb_search_location');
				sessionStorage.removeItem('ttmb_search_lat');
				sessionStorage.removeItem('ttmb_search_lng');
				sessionStorage.removeItem('ttmb_trail_results');
				location.reload();
				
			});
			
		},
		
		submission_click_handler : function()
		{
			
			$(document).on('click', '.ttmb-submission-data-reveal', function()
			{
				
				var button = $(this);
				
				if($('#ttmb-submission-answer-data').hasClass('ttmb-sad-open'))
				{
					
					$('html, body').animate({
						scrollTop: $('#ttmb-submission-result').offset().top
					}, 500);
					
					$('#ttmb-submission-answer-data').removeClass('ttmb-sad-open').slideUp('slow');
					button.text(button.text().replace('hide', 'show'));
					
				} else {
					
					setTimeout(function()
					{
						
						$('html, body').animate({
							scrollTop: $('#ttmb-submission-answer-data').offset().top
						}, 500);		
						
					}, 500);

					$('#ttmb-submission-answer-data').addClass('ttmb-sad-open').slideDown('slow');
					button.text(button.text().replace('show', 'hide'));

				}
				
			});
			
			$(document).on('click', '.ttmb-submission-map-scroll', function()
			{
				$('html, body').animate({
					scrollTop: $('.ttmb-tny-title').offset().top - 10
				}, 500);
			});			
			
		},
      
        stockists_results : function(features, queried = false)
        {
          
          	var html = '';
			
			html = html + '<div class="ttmbs-result-count">Total Stockists: ' + features.length + '</div>';
        
            features.forEach(function(feature)
            {
				
					if(queried)
					{
					html = html + '<div class="ttmbs-result-item ttmbs-result-item-queried">';	
					} else {
					html = html + '<div class="ttmbs-result-item">';	
					}

                	html = html + '<h5>' + feature.properties.title + '</h5>';
              		html = html + '<address>';
              			html = html + feature.properties.street + '<br />';
              			html = html + feature.properties.city + ', ';
              			html = html + feature.properties.county + ', ';
              			html = html + feature.properties.postcode;
              		html = html + '</address>';
              
              		html = html + '<a class="ttmbs-ri-phone" href="call:' + feature.properties.phone + '">' + feature.properties.phone + '</a>';
              		html = html + '<a class="ttmbs-ri-directions" href="https://www.google.com/maps/place/' + feature.geometry.coordinates[1] + ',' + feature.geometry.coordinates[0] + '" target="_blank">Get Directions</a>';

                html = html + '</div>';

            });
          
            return html;
        
        },
      
        stockist_search : function(features, map)
        {
          
          	var self = this,
				form = '#ttmbs-search';
        
        	$(form).on('submit', function(e)
            {
              
              	e.preventDefault();
              
            });
          
        	$(form + ' input[type="search"]').off('keyup').on('keyup', function(e)
            {
				
              	var location = $(this);
				
				if(location.val() !== '' && location.val().length > 3)
                {

					self.get_searched_location(location.val(), form);
					
				} else if(location.val() == '') {
					
					sessionStorage.removeItem('ttmb_search_geo');
					sessionStorage.removeItem('ttmb_search_location');
					sessionStorage.removeItem('ttmb_search_lat');
					sessionStorage.removeItem('ttmb_search_lng');
					sessionStorage.removeItem('ttmb_trail_results');
					
					if(window.location.href.indexOf('?') > -1)
					{
						
						window.location.href = window.location.pathname;
						
					} else {
						
						window.location.reload();
						
					}
					
				}
              
            });
        
        },
          
		add_trail_search_event : function()
		{
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'trailSearch'
			});
		},
		
		global_search : function()
		{
		
          	var self = this,
				form = '.tt-search-header';
				
			// Set the current location in search form there is one

			if(sessionStorage.hasOwnProperty('ttmb_search_location'))
			{
				
				var current_search = sessionStorage.getItem('ttmb_search_location');
			
				// Set the value within the search field
				
				setTimeout(function()
				{
					// $('.tt-search-header input[name="location"]').val(current_search.split(',')[0]);
				}, 2000);
			
			} else {
				
				if($('#ttmb-filter-nav-toggle').length > 0)
				{
					// $('#ttmb-filter-nav-toggle').hide();
				}
				
			}
			
			// Global Search
        
        	$(form).on('submit', function(e)
            {
              
              	e.preventDefault();
              
            });
			
			var current_index = 0,
				keydown_triggered = false;
          
        	$(form + ' input[type="search"]').off('keyup').on('keyup', function(e)
            {
				
              	var location = $(this),
					results_count = $('.ttmb-search-autocomplete-item').length;
				
				if(location.val() !== '' && location.val().length > 3)
                {
					
					if(e.which !== 37 && e.which !== 38 && e.which !== 39 && e.which !== 40)
					{
						
						self.get_searched_location(location.val(), form, true);
					
					} else if(e.which == 38) {
						
						// Up

						if(current_index == 0)
						{
							current_index = results_count;
						}
						
						if(current_index > 0) {
							current_index = current_index - 1;
						}
						
						$('.ttmb-search-autocomplete-item').removeClass('ttmb-search-autocomplete-active');
						$('.ttmb-search-autocomplete > div[data-index="' + current_index + '"]').addClass('ttmb-search-autocomplete-active');
						
					} else if(e.which == 40) {
						
						// Down
						
						if(current_index == results_count-1)
						{
							current_index = -1;
						}
						
						if(current_index < results_count && keydown_triggered) {
							current_index = current_index + 1;
						}
						
						if(!keydown_triggered)
						{
							keydown_triggered = true;
						}
						
						$('.ttmb-search-autocomplete-item').removeClass('ttmb-search-autocomplete-active');
						$('.ttmb-search-autocomplete > div[data-index="' + current_index + '"]').addClass('ttmb-search-autocomplete-active');
						
					}
					
					if(e.which == 13) {

						// Enter Button

                        $(self.loader()).appendTo('body');
                      
                      	self.add_trail_search_event();

						var entered_element = $('.ttmb-search-autocomplete-active');
						
						if(entered_element.length == 0)
						{
							entered_element = $('.ttmb-search-autocomplete-item:first');
						}
						
						var title = entered_element.data('name'),
							lat   = entered_element.data('lat'),
							lng   = entered_element.data('lng'),
							wrap  = entered_element.closest('.ttmb-search-autocomplete');
							
						// Fade out autocomplete and remove element
							
						wrap.fadeOut(function()
						{
							$(this).remove();
						});
						
						// Store queried location
						
						self.storage('ttmb_search_location', title, 'set');
						self.storage('ttmb_search_lat', lat, 'set');
						self.storage('ttmb_search_lng', lng, 'set');
						
						// Set the value within the search field
						
						$(form + ' input[type="search"]').val(title.split(',')[0]);
						
						// Filter selection through smart queries
						
						self.smart_queries(title);
						
						setTimeout(function()
						{
							
							// Refresh
							
							var current_value = $(form + ' input[type="search"]');
							var split_current_val = current_value.val().split(',');
							var form_action = $(form).attr('action');
							
							if (typeof attr !== typeof undefined && attr !== false) {
								window.history.replaceState("", "", form_action);
								setTimeout(function()
								{
									$('#ttmb-loader-outer').remove();
								}, 2000);
							} else {
								// If there are no search parameters, redirect back to the homepage
								window.location.replace("/");
							}
							
							if('URLSearchParams' in window) {
								var searchParams = new URLSearchParams(window.location.search);
								searchParams.set(current_value.attr('name'), split_current_val[0]);
								window.location.search = searchParams.toString();
							}
							
						}, 2000);

					}

				} else if(location.val() == '') {
					
					sessionStorage.removeItem('ttmb_search_geo');
					sessionStorage.removeItem('ttmb_search_location');
					sessionStorage.removeItem('ttmb_search_lat');
					sessionStorage.removeItem('ttmb_search_lng');
					sessionStorage.removeItem('ttmb_trail_results');
					
					if(window.location.href.indexOf('?') > -1)
					{
						
						window.location.href = window.location.pathname;
						
					} else {
						
						window.location.reload();
						
					}
					
				}
              
            });

			/*

			$(form).off('submit').on('submit', function(e)
			{
				$(self.loader()).appendTo('body');

				self.add_trail_search_event();
			  
				var submitted_element = $('.ttmb-search-autocomplete-active');
				
				if(submitted_element.length == 0)
				{
					submitted_element = $('.ttmb-search-autocomplete-item:first');
				}
				
				var title = submitted_element.data('name'),
					lat   = submitted_element.data('lat'),
					lng   = submitted_element.data('lng'),
					wrap  = submitted_element.closest('.ttmb-search-autocomplete');
					
				// Fade out autocomplete and remove element
					
				wrap.fadeOut(function()
				{
					
					$(this).remove();
					
				});
				
				// Store queried location
				
				self.storage('ttmb_search_location', title, 'set');
				self.storage('ttmb_search_lat', lat, 'set');
				self.storage('ttmb_search_lng', lng, 'set');
				
				// Set the value within the search field
				
				$(form + ' input[type="search"]').val(title.split(',')[0]);
				
				// Filter selection through smart queries
				
				self.smart_queries(title);

				setTimeout(function()
				{
					
					// Refresh
					
					var current_value = $(form + ' input[type="search"]');
					var split_current_val = current_value.val().split(',');
					var form_action = $(form).attr('action');
					
					if (typeof attr !== typeof undefined && attr !== false) {
						window.history.replaceState("", "", form_action);
						setTimeout(function()
						{
							$('#ttmb-loader-outer').remove();
						}, 2000);
					} else {
						// If there are no search parameters, redirect back to the homepage
						window.location.replace("/");
					}
					
					if('URLSearchParams' in window) {
						var searchParams = new URLSearchParams(window.location.search);
						searchParams.set(current_value.attr('name'), split_current_val[0]);
						window.location.search = searchParams.toString();
					}
					
				}, 2000);
			});

			*/
		
		},
      
        stockist_hover : function(map)
        {
			
			var self = this;

			$('.ttmbs-result-item:not(.ttmbs-result-item-queried)').on({
			  mouseenter: function()
			  {
				map.removeLayer(self.get_id());
				var title = $(this).find('h5').text();
				var filters = ['any'];
				filters.push(['==', 'title', title]);
				map.addLayer({
				  'id': self.get_id(),
				  'type': 'symbol',
				  'source': self.get_id(),
				  'layout': {
					'icon-image': 'tt_map_icon',
					'icon-size': 0.9,
					'icon-allow-overlap': true
				  },
				  'filter': filters
				});
			  }
			});

			$('body:not(.ttmb-search-query-active) #mapbox-stockists').on({
			  mouseleave: function()
			  {
				map.removeLayer(self.get_id());
				map.addLayer({
				  'id': self.get_id(),
				  'type': 'symbol',
				  'source': self.get_id(),
				  'layout': {
					'icon-image': 'tt_map_icon',
					'icon-size': 0.9,
					'icon-allow-overlap': true
				  }
				});
			  }
			});
          
        },
		
		get_query_string_param : function(param)
		{
			
			var sPageURL = window.location.search.substring(1),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === param) {
					return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
				}
			}
			
		},
		
		prettify_query_string_param : function(str)
		{
			var splitStr = str.replace(/-/g, ' ');
			var prettyStr = splitStr.replace( /\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();} );
			return prettyStr;
		},
		
		toggle : function()
		{
			
			var container  = $('.pltt-toggle-block');
				
			$(container).each(function()
			{
				
				var current    = $(this),
					table_wrap = current.find('.pltt-table-wrap'),
					title      = current.find('h2'),
              		storage_title = title.text().toLowerCase().replace(' ', '_') + '_open';
					
				table_wrap.hide();
              
              	if(localStorage.hasOwnProperty(storage_title))
                {
                
                	var is_toggled = localStorage.getItem(storage_title);
                  
                  	if(is_toggled == 'yes')
                    {
                    	table_wrap.show();
                        current.addClass('pltt-title-toggled');
                    } else {
                    	current.removeClass('pltt-title-toggled');
                    }
                  
                }
					
				$(title).on('click', function()
				{
					
					table_wrap.slideToggle(function()
                    {
                      if($(this).is(':visible'))
                      {
                          localStorage.setItem(storage_title, 'yes');
                      	  current.addClass('pltt-title-toggled');
                      } else {
                          localStorage.setItem(storage_title, 'no');
                          current.removeClass('pltt-title-toggled');
                      }
                    });
					
				});
				
			});
			
		},
		
		set_queried_location : function()
		{
			
			var self = this,
				queried_location = self.get_query_string_param('location'),
				queried_search = self.get_query_string_param('search');
				
			if(queried_location !== undefined || queried_search !== undefined)
			{
				
				if(!sessionStorage.hasOwnProperty('ttmb_search_location') && !sessionStorage.hasOwnProperty('ttmb_search_lat') && !sessionStorage.hasOwnProperty('ttmb_search_lng') && !sessionStorage.hasOwnProperty('ttmb_search_geo'))
				{
					
					var mapbox_geo_api = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + queried_location + '.json?country=GB&types=region,postcode,place,locality,district,poi&autocomplete=true&access_token=' + self.public_access_token();

					$.ajax({

						type: 'GET',
						url: mapbox_geo_api,
						crossDomain: true,

						success : function(data) 
						{

							// Store GEO data
							self.storage('ttmb_search_geo', JSON.stringify(data), 'set');
							
							if(data.features && data.features[0] !== undefined)
							{
								var result = data.features[0];
								self.storage('ttmb_search_location', result.place_name, 'set');
								self.storage('ttmb_search_lat', result.geometry.coordinates[1], 'set');
								self.storage('ttmb_search_lng', result.geometry.coordinates[0], 'set');
								// self.set_all_features();
								return self.get_geojson();
							}

						},

						error: function (jqXHR, exception)
						{

							var error = '';

							if (jqXHR.status === 0) {
								error = 'Can\'t connect.\n Verify Network.';
							} else if (jqXHR.status == 404) {
								error = 'Requested page not found. [404]';
							} else if (jqXHR.status == 500) {
								error = 'Internal Server Error [500].';
							} else if (exception === 'parsererror') {
								error = 'Requested JSON parse failed.';
							} else if (exception === 'timeout') {
								error = 'Time out error.';
							} else if (exception === 'abort') {
								error = 'Ajax request aborted.';
							} else {
								error = 'Uncaught Error.\n' + jqXHR.responseText;
							}

							alert(error);

						},

					});
					
				} else {
					$('#ttmb-search').find('input[type="search"]').text('');
					$('#ttmb-search').find('input[type="search"]').val('');
					$('#ttmbs-search').find('input[type="search"]').text('');
					$('#ttmbs-search').find('input[type="search"]').val('');
					// self.set_all_features();
					return self.get_geojson();
				}

			} else {
				sessionStorage.removeItem('ttmb_search_location');
				sessionStorage.removeItem('ttmb_search_lat');
				sessionStorage.removeItem('ttmb_search_lng');
				sessionStorage.removeItem('ttmb_search_geo');
				$('#ttmb-search').find('input[type="search"]').text('');
				$('#ttmb-search').find('input[type="search"]').val('');
				$('#ttmbs-search').find('input[type="search"]').text('');
				$('#ttmbs-search').find('input[type="search"]').val('');
                self.focus_search_form();
				// self.set_all_features();
				return self.get_geojson();
			}
			
		},


        focus_search_form : function()
        {
            const current_path = window.location.pathname;

            if(~current_path.indexOf('trail-search'))
            {
                window.addEventListener('load', function () {
                    $('.tt-search').slideDown('slow');
                    $('body').addClass('pltt-focus-search');
                });
            }
        },
		
		build_map : function(touch_point, dataset)
		{
			
			var self = this;
			
			// Set Access Token
			
			mapboxgl.accessToken = self.public_access_token();
			
			// Set features
			
			var features = dataset.features;
			
			// Active Style
			
			var active_style = sessionStorage.hasOwnProperty('ttmb_active_filter') ? sessionStorage.getItem('ttmb_active_filter') : 'streets-v11';
			
			if(touch_point == 'quaternary')
			{
				
				// Fetch data from shopify.treasuretrails.co.uk
				
				var customer_data = JSON.parse(sessionStorage.getItem('ttmb_answer_data'));
				
				if(customer_data !== null)
				{
				
					// Initialise Map
					
					var map = new mapboxgl.Map({
						container: 'mapbox-renderer',
						style: 'mapbox://styles/mapbox/' + active_style,
						center: [customer_data.coordes.lng, customer_data.coordes.lat],
						zoom: 4
					});
				
				} else {
					
					// Initialise Map
					
					var map = new mapboxgl.Map({
						container: 'mapbox-renderer',
						style: 'mapbox://styles/mapbox/' + active_style,
						center: [self.get_lng(), self.get_lat()],
						zoom: 4
					});	
					
				}
				
			} else {
				
				// Initialise Map
				
				var map = new mapboxgl.Map({
					container: 'mapbox-renderer',
					style: 'mapbox://styles/mapbox/' + active_style,
					center: [self.get_lng(), self.get_lat()],
					zoom: 4
				});
				
			}
			
			// On Map Load
			
			map.on('load', function()
			{
					
				// Load custom icon and run map functions
				
				map.loadImage(
				
					// Fetch image asset from Shopify
				
					self.get_map_icon(),
					
					function(error, image)
					{
						
						// Throw error, otherwise load image
						
						if(error)throw error;
						map.addImage('tt_map_icon', image);
						
						// Add dataset as source that's stored in sessionStorage
						
						map.addSource(self.get_id(), {
							type: 'geojson',
							data: dataset
						});
						
						self.map_zoom(map);
						
						// Create bounds
						
						var bounds      = new mapboxgl.LngLatBounds(),
							bound_count = 0;
						
						// Add layer from source
						
						if(touch_point == 'primary')
						{
							
							// Iterate through each feature to set bounds against feature if Product ID matches
							
							features.forEach(function(feature)
							{
								
								if(!map.getLayer(feature.id))
								{

									if($.isArray(self.get_filtered_products(false)))
									{
										
										if($.inArray(feature.properties.product_id, self.get_filtered_products(false)) != -1)
										{
										
											bounds.extend(feature.geometry.coordinates);
											bound_count++;
										
										}
										
									} else {
										
										if(feature.properties.product_id == self.get_filtered_products(false))
										{
										
											bounds.extend(feature.geometry.coordinates);
											bound_count++;
										
										}
										
									}
									
								}
								
							});
							
							map.addLayer({
								'id': self.get_id(),
								'type': 'symbol',
								'source': self.get_id(),
								'layout': {
									'icon-image': 'tt_map_icon',
									'icon-size': 1,
									'icon-allow-overlap': true
								},
								'filter': self.get_filtered_products()
							});
							
							// Center all bounds on the map if there's more than one location, otherwise fit bounds but set maxZoom level
							
							if(bound_count > 2)
							{
							
								map.fitBounds(bounds, {padding: 50});
							
							} else {
							
								map.fitBounds(bounds, {padding: 50, maxZoom: 15});
							
							}
							
						} else if(touch_point == 'secondary') {
							
							self.build_map_by_region(self.sort_data('name', features, 'asc'), map);
							
							if(sessionStorage.hasOwnProperty('ttmb_trail_results'))
							{
							
								var trail_results = JSON.parse(sessionStorage.getItem('ttmb_trail_results'));
								self.render_collection_results(trail_results);
							
							}
							
							$(self.trail_filters_html()).prependTo('body');
							self.trail_filters_reshuffle();
							self.trail_filter_click_handler();
							// self.sticky_element('.section-header-wrap', '.ttmb-search-container');
							
						} else if(touch_point == 'tertiary') {
							
							// Iterate through each feature to set bounds against feature if Product ID matches
							
							features.forEach(function(feature)
							{
								
								if(!map.getLayer(feature.id))
								{

									bounds.extend(feature.geometry.coordinates);
									bound_count++;
									
								}
								
							});
							
							map.addLayer({
								'id': self.get_id(),
								'type': 'symbol',
								'source': self.get_id(),
								'layout': {
									'icon-image': 'tt_map_icon',
									'icon-size': 0.9,
									'icon-allow-overlap': true
								}
							});
							
							// Center all bounds on the map if there's more than one location, otherwise fit bounds but set maxZoom level
							
							if(bound_count > 2)
							{
							
								map.fitBounds(bounds, {padding: 50});
							
							} else {
							
								map.fitBounds(bounds, {padding: 50, maxZoom: 15});
							
							}
							
                        } else if(touch_point == 'quaternary') {
							
							// Build vars for iteration
							
							var product_lat  = customer_data.coordes.lat,
								product_lng  = customer_data.coordes.lng,
								product_ids = $.map(customer_data.all_product_ids, function(value, index){
								return [value];
							});
                          
							// Iterate through each feature to set bounds against feature if Product ID matches
								
							var filters = ['any'],
								active_features = {};
								
							// Remove duplicate results title
							
							$('.ttmb-tny-title').first().remove();
							
							features.forEach(function(feature)
							{
								
								if(!map.getLayer(feature.id))
								{

									var to = [product_lng, product_lat],
										from = feature.geometry.coordinates,
										options = {
											units: 'miles'
										},
										distance = turf.distance(to, from, options);
										
									if(distance <= sessionStorage.getItem('ttmb_distance') && $.inArray(parseInt(feature.properties.product_id), product_ids) == -1)
									{

										filters.push(['==', 'product_id', parseInt(feature.properties.product_id)]);
										feature.properties.distance_to = distance.toFixed(1);
										feature.distance = distance.toFixed(1);
										active_features[feature.properties.product_id] = feature;
										bounds.extend(feature.geometry.coordinates);
										bound_count++;
										
									}
									
								}
								
							});
							
							map.addLayer({
								'id': self.get_id(),
								'type': 'symbol',
								'source': self.get_id(),
								'layout': {
									'icon-image': 'tt_map_icon',
									'icon-size': 0.9,
									'icon-allow-overlap': true
								},
								'filter': filters
							});
							
							var radius = new MapboxCircle({lat: product_lat, lng: product_lng}, self.miles_to_meter(sessionStorage.getItem('ttmb_distance')), {
									editable: false,
									minRadius: self.miles_to_meter(sessionStorage.getItem('ttmb_distance')),
									fillColor: '#0297d6'
								}).addTo(map);
		
							self.render_trail_results(self.sort_data('distance', active_features, 'asc'), true);
								
							// Center all bounds on the map if there's more than one location, otherwise fit bounds but set maxZoom level
							
							if(bound_count > 2)
							{
							
								map.fitBounds(bounds, {padding: 50});
							
							} else {
							
								map.fitBounds(bounds, {padding: 50, maxZoom: 15});
							
							}
							
							// map.setMaxBounds(bounds);
							// map.setZoom(3);
                        
                        } else if(touch_point == 'stockists') {
							
							// Set current location

							var current_search = sessionStorage.getItem('ttmb_search_location');
							
							if(sessionStorage.hasOwnProperty('ttmb_search_location'))
							{
							
								// Set the value within the search field
								
								$('#ttmbs-search input[name="search"]').val(current_search.split(',')[0]);
							
							}
							
							if(sessionStorage.hasOwnProperty('ttmb_search_lat') && sessionStorage.hasOwnProperty('ttmb_search_lng'))
							{
							
								// Build the Map
								
								self.build_map_by_location(features, map, sessionStorage.getItem('ttmb_search_lat'), sessionStorage.getItem('ttmb_search_lng'));
							
							}
							
							if(!map.getLayer(self.get_id())) {
                          
								// Add Results to left sidebar
							  
								$(self.stockists_results(features)).appendTo($('#ttmbs-results'));
							  
								// Add search by Keyup
							  
								self.stockist_search(features, map);
							
								// Iterate through each feature to set bounds against feature
								
								features.forEach(function(feature)
								{
									
									if(!map.getLayer(feature.id))
									{

										bounds.extend(feature.geometry.coordinates);
										bound_count++;
										
									}
									
								});
							  
								// Add Default Layer
								
								map.addLayer({
									'id': self.get_id(),
									'type': 'symbol',
									'source': self.get_id(),
									'layout': {
										'icon-image': 'tt_map_icon',
										'icon-size': 0.9,
										'icon-allow-overlap': true
									}
								});
								
								self.stockist_hover(map);
								
								// Center all bounds on the map if there's more than one location, otherwise fit bounds but set maxZoom level
								
								if(bound_count > 2)
								{
								
									map.fitBounds(bounds, {padding: 50});
								
								} else {
								
									map.fitBounds(bounds, {padding: 50, maxZoom: 15});
								
								}
							
							}
							
						} else if(touch_point == 'search') {
							
							// Set current location
							
							if(sessionStorage.hasOwnProperty('ttmb_search_lat') && sessionStorage.hasOwnProperty('ttmb_search_lng'))
							{
							
								// Build the Map
								
								self.build_map_by_location(features, map, sessionStorage.getItem('ttmb_search_lat'), sessionStorage.getItem('ttmb_search_lng'), false, false, true);
								
								// Render Product Grid
								
								if(sessionStorage.hasOwnProperty('ttmb_trail_results'))
								{
								
									var trail_results = JSON.parse(sessionStorage.getItem('ttmb_trail_results'));
									self.render_trail_results(trail_results);
								
								}
								
							}
							
							// Render Filters HTML and it's click handler
							
							$(self.trail_filters_html()).prependTo('body');
							// $(self.trail_filter_toggle_html()).appendTo($('#mapbox-container'));
							self.trail_filters_reshuffle();
							self.trail_filter_click_handler();
							// self.sticky_element('.section-header-wrap', '.ttmb-search-container');
							
							if(!sessionStorage.hasOwnProperty('ttmb_search_lat') && !sessionStorage.hasOwnProperty('ttmb_search_lng') && !map.getLayer(self.get_id())) {
							  
								// Add search by Keyup
							  
								self.stockist_search(features, map);
							
								// Iterate through each feature to set bounds against feature
								
								features.forEach(function(feature)
								{
									
									if(!map.getLayer(feature.id))
									{

										bounds.extend(feature.geometry.coordinates);
										bound_count++;
										
									}
									
								});
							  
								// Add Default Layer
								
								map.addLayer({
									'id': self.get_id(),
									'type': 'symbol',
									'source': self.get_id(),
									'layout': {
										'icon-image': 'tt_map_icon',
										'icon-size': 0.9,
										'icon-allow-overlap': true
									},
									'filter': self.build_filter_results(features, map, bounds)
								});
								
								// Center all bounds on the map if there's more than one location, otherwise fit bounds but set maxZoom level
								
								if(bound_count > 2)
								{
								
									map.fitBounds(bounds, {padding: 50});
								
								} else {
								
									map.fitBounds(bounds, {padding: 50, maxZoom: 15});
								
								}
							
							}
							
							$('#ttmb-bestsellers-wrap').slideDown('slow');

						} else if(touch_point == 'trails_nearby') {
							
							if(sessionStorage.hasOwnProperty('ttmb_current_lat') && sessionStorage.hasOwnProperty('ttmb_current_lng'))
							{

								// Build the Map
								
								self.build_map_by_location(features, map, sessionStorage.getItem('ttmb_current_lat'), sessionStorage.getItem('ttmb_current_lng'), false, false, false);
							
							}
                        
                        }
						
						// Click Handlers
						
						self.map_click_handlers(map);

					}
					
				);
				
			});
			
		},
		
		renderer : function(dataset)
		{
			
			var self = this;
			
			// Execute map based off touch point
			
			if(self.get_type() !== 'undefined')
			{
			
				if(self.get_type() == 'primary')
				{
					
					// Start Up Tasks
					
					self.add_map_status();
					// bself.map_style_switcher();
					
					// Render Map
					
					return self.build_map(self.get_type(), dataset);
					
				} else if(self.get_type() == 'secondary') {
					
					// Start Up Tasks
					
					self.add_map_status();
					// self.map_style_switcher();
					
					// Render Map
					
					return self.build_map(self.get_type(), dataset);
					
				} else if(self.get_type() == 'tertiary') {
					
					// Start Up Tasks
					
					self.add_map_status();
					// self.map_style_switcher();
					
					// Render Map
					
					return self.build_map(self.get_type(), dataset);
					
				} else if(self.get_type() == 'quaternary') {
					
					setTimeout(function()
					{
					
						if(sessionStorage.hasOwnProperty('ttmb_submission_data'))
						{

							var submission_data = JSON.parse(sessionStorage.getItem('ttmb_submission_data'));
							var customer_data = JSON.parse(sessionStorage.getItem('ttmb_answer_data'));
							
							$('#mapbox-container').hide();
							
							self.submission_result(dataset);
							
							if(submission_data.email !== null && submission_data.product_id !== null && customer_data !== null && customer_data.coordes !== undefined)
							{
							
								// Start Up Tasks
							
								$('#mapbox-container').show();
								self.add_map_status();
								// self.map_style_switcher();
								self.map_distance_switcher();
								
								if($(window).width() < 751) {
								
									setTimeout(function()
									{
										$('html, body').animate({
											scrollTop: $('#ttmb-submission-result').offset().top
										}, 500);
									}, 1000);
								
								}
								
								// Render Map
								
								// return self.build_map(self.get_type(), dataset);
							
							} else {
								$('#ttmb-trails-nearby').hide();
							}
							
						} else {
							
							$('#mapbox-container').hide();
							self.urn_form();
							
						}
					
					}, 500);
                  
                  	self.submission_click_handler();
					
				} else if(self.get_type() == 'stockists') {
                  
                    // Start Up Tasks

                    self.add_map_status();
                    // self.map_style_switcher();
                    self.map_distance_switcher();

                    // Render Map

                    return self.build_map(self.get_type(), dataset);
                  
                } else if(self.get_type() == 'search') {
					
					// Start Up Tasks

					self.add_map_status();
					// self.map_style_switcher();
					
					if(sessionStorage.hasOwnProperty('ttmb_search_lat') && sessionStorage.hasOwnProperty('ttmb_search_lng'))
					{
					
						self.map_distance_switcher();
						self.view_switcher();
					
					}

					// Render Map

					return self.build_map(self.get_type(), dataset);
					
				} else if(self.get_type() == 'trails_nearby') {
					
					function render_map(position)
					{
						
						$('.ttmb-geo-button-wrap').fadeOut(function()
						{
							
							$(this).remove();
							
						});

						sessionStorage.setItem('ttmb_current_lat', position.coords.latitude);
						sessionStorage.setItem('ttmb_current_lng', position.coords.longitude);
						
						// Start Up Tasks

						self.add_map_status();
						// self.map_style_switcher();
						self.map_distance_switcher();

						// Render Map

						return self.build_map(self.get_type(), dataset);
						
					}
					
					var getPosition = function(options)
					{
						return new Promise(function (resolve, reject) {
							navigator.geolocation.getCurrentPosition(resolve, reject, options);
						});
					}
					
					var geo_button = '<div class="ttmb-geo-button-wrap"><span class="ttmb-geo-button">Use my Current Location to Load Map</span></div>';
					$(geo_button).appendTo($('#geoDistanceMap #mapbox-container'));

					if(navigator.permissions && navigator.permissions.query)
					{

						navigator.permissions.query({name:'geolocation'}).then(function(result)
						{
							
							if(result.state == 'granted')
							{

								getPosition()
									.then((position) => {
										render_map(position);
									})
									.catch((err) => {
										console.error(err.message);
									});
						
							} else if(result.state == 'prompt') {
							
								$('.ttmb-geo-button').on('click', function()
								{
									
									getPosition()
										.then((position) => {
											render_map(position);
										})
										.catch((err) => {
											console.error(err.message);
										});
									
								});
								
							}
						
						});
						
					} else if(navigator.geolocation) {
						
						$('.ttmb-geo-button').on('click', function()
						{
							
							getPosition()
								.then((position) => {
									render_map(position);
								})
								.catch((err) => {
									console.error(err.message);
								});
							
						});
						
					}
                  
                }
			
			} else {return '';}
			
		},

        equalizer : function()
        {
            var bestseller_items = $('#ttmb-bestsellers .prodCardGrid .inner'),
                heights = [];

            $.each(bestseller_items, function(index, item)
            {
                heights.push(Math.ceil($(item).height()));
            });

            var max_height = Math.max.apply(Math,heights);
          
            $.each(bestseller_items, function(index, item)
            {
                $(item).css('min-height', max_height);
            });
        }

	};

	PushLogic_Mapbox.init();

})(jQuery); 